
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import loader from "../../../assets/Images/loader.gif"
import { components as RSComponents } from 'react-select'
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as api from "../../../api_function";

// const optionBusiness = ["Select Business Segment ","Business"];


const optionTurnOver = [
    { label: "Select Option", value: "0" },
    { label: "<1 Cr", value: "1" },
    { label: "1 - 10 Cr", value: "2" },
    { label: "10 - 100 Cr", value: "3" },
    { label: "100 - 500 Cr", value: "4" },
    { label: ">500 Cr", value: "5" }
]

const optionDesignation = [
    { label: "Select Option", value: "0" },
    { label: "General Manager", value: "111260008" },
    { label: "Owner/Director", value: "111260009" },
    { label: "Sales", value: "111260010" },
    { label: "IT", value: "111260011" },
    { label: "Procurement", value: "111260012" },
    { label: "Other", value: "111260003" },

]


const optionBarrier = [
    { label: "Select Option", value: "0" },
    { label: "Building Gate", value: "1" },
    { label: "Office Reception", value: "2" },
    { label: "Cleared", value: "3" },

]

const optionOfficeArea = [
    { label: "Select Option", value: "0" },
    { label: "0 - 600", value: "1" },
    { label: "600 - 1200", value: "2" },
    { label: ">1200", value: "3" },

]

const optionExistConnectivity = [
    { label: "Select Option", value: "0" },
    { label: "ILL", value: "1" },
    { label: "BB", value: "2" },
    { label: "New Building", value: "3" },
]

const optionApplications = [
    { label: "Select Option", value: "0" },
    { label: "Cloud & Storage (AWS, Azure, etc.)", value: "1" },
    { label: "Microsoft Teams, Zoom", value: "2" },
    { label: "HRMS", value: "3" },
    { label: "CRM (Salesforce, Zoho, etc.)", value: "4" },
    { label: "ERP / SAP", value: "5" },
    { label: "Microsoft Dynamics 365", value: "6" },
]

const optionProductName = [
    { label: "Select Option", value: "0" },
    { label: "Pro-Fi Broadband", value: "1" },
    { label: "BB", value: "2" },
    { label: "New Building", value: "3" },
]

const optionSubBusiness = [
    { value: "0", label: "Select Sub Business Segment" },
    { value: "Connectivity Solution", label: "Connectivity Solution" },
    { value: "Data Centre Products", label: "Data Centre Products" },
    { value: "Internet Service", label: "Internet Service" },
    { value: "SDWAN", label: "SDWAN" },
    { value: "SIP-Trunk", label: "SIP-Trunk" },
    { value: "VOIP", label: "VOIP" },
    { value: "Video Analytics", label: "Video Analytics" },
];
const optionCustomerSeg = [
    { label: "Select Customer Segment", value: "0" },
    { label: "SDWAN", value: "111260004" },
    { label: "SMB", value: "111260000" },
    { label: "Media", value: "111260001" },
    { label: "LA", value: "111260002" },
    { label: "SP", value: "111260003" },
];
const optionSalutation = [
    { label: "Select Salutation", value: "0" },
    { label: "Mr.", value: "1" },
    { label: "Mrs.", value: "2" },
    { label: "Miss", value: "3" },
];
//const optionRelationship = ["Select Relationship"];
const optionLeadChannel = [
    { label: "Select Channel", value: "" },
    { label: "FFA APP", value: "FFA App" },
    { label: "Self Lead", value: "Self Lead" },
    { label: "Call/SMS-Inbound", value: "Call/SMS-Inbound" },
    { label: "Caretel", value: "Caretel" },
    { label: "CM Outbound", value: "CM Outbound" },
    { label: "Email/Email Campaigns", value: "Email/Email Campaigns" },
    { label: "Inside Sales", value: "Inside Sales" },
    { label: "Inside Sales-QC", value: "Inside Sales-QC" },
    { label: "Kaizala", value: "Kaizala" },
    { label: "NetOps Channel", value: "NetOps Channel" },
    { label: "Online CAF", value: "Online CAF" },
    { label: "Outbound Call", value: "Outbound Call" },
    { label: "Paid Campaign/Activity", value: "Paid Campaign/Activity" }, {
        label: "Promotion/BTL/ATL/Events/Sponsorship/Visibility Activity",
        value: "Promotion/BTL/ATL/Events/Sponsorship/Visibility Activity",
    },
    { label: "Self Care Portal", value: "Self Care Portal" },
    { label: "Unify Churned", value: "Unify Churned" },
    { label: "Web Campaign", value: "Web Campaign" },
];

const optionCountry = [{ label: "India", value: "10001" }];
const optionCountryOne = [{ label: "India", value: "10001" },];


const paymentoptions = [
    { value: "111260001", label: "Agreed" },
    // { value: "111260002", label: "Not Agreed" },
];



const internetProviderOptions = [
    { value: "111260000", label: "Airtel" },
    { value: "111260001", label: "Jio" },
    { value: "111260002", label: "Tata" },
    { value: "111260003", label: "ACT" },
    { value: "111260006", label: "Excitel" },
    { value: "111260007", label: "Triple Play" },
    { value: "111260004", label: "New Building" },
    { value: "111260005", label: "Others" },
];
const spectraRelationshipOptions = [
    { value: "111260000", label: "Existing User" },
    { value: "111260001", label: "Past User" },
    { value: "111260002", label: "New" },
];
const internetOutflowOptions = [
    { value: "111260000", label: "<5000" },
    { value: "111260001", label: "5001 - 10000" },
    { value: "111260008", label: "10001 - 20000" },
    { value: "111260009", label: ">20,000" },

    { value: "111260006", label: "New Building" },
    { value: "111260007", label: "Others" },
];



const roleOptions = [
    { value: "111260000", label: "KDM" },
    { value: "111260001", label: "Influencer" },
];
const optionState = [
    { name: "Select State", code: "" },
    { name: "Andhra Pradesh", code: "100009" },
    { name: "Jharkhand", code: "100030" },
    { name: "Bihar", code: "100021" },
    { name: "Delhi", code: "100004" },
    { name: "Gujarat", code: "100015" },
    { name: "Haryana", code: "100008" },
    { name: "Jammu and Kashmir", code: "100011" },
    { name: "Karnataka", code: "100007" },
    { name: "Kerala", code: "100012" },
    { name: "Madhya Pradesh", code: "100014" },
    { name: "Maharashtra", code: "100002" },
    { name: "Odisha", code: "100026" },
    { name: "Other*", code: "100017" },
    { name: "Punjab", code: "100025" },
    { name: "Rajasthan", code: "100010" },
    { name: "Tamil Nadu", code: "100003" },
    { name: "Telangana", code: "100023" },
    { name: "Uttar Pradesh", code: "100006" },
    { name: "Uttarakhand", code: "100016" },
    { name: "West Bengal", code: "100013" },
    { name: "Goa", code: "100028" },
];
const optionStateOne = [
    { name: "Select State", code: "" },
    { name: "Andhra Pradesh", code: "100009" },
    { name: "Jharkhand", code: "100030" },
    { name: "Bihar", code: "100021" },
    { name: "Delhi", code: "100004" },
    { name: "Gujarat", code: "100015" },
    { name: "Haryana", code: "100008" },
    { name: "Jammu and Kashmir", code: "100011" },
    { name: "Karnataka", code: "100007" },
    { name: "Kerala", code: "100012" },
    { name: "Madhya Pradesh", code: "100014" },
    { name: "Maharashtra", code: "100002" },
    { name: "Odisha", code: "100026" },
    { name: "Other*", code: "100017" },
    { name: "Punjab", code: "100025" },
    { name: "Rajasthan", code: "100010" },
    { name: "Tamil Nadu", code: "100003" },
    { name: "Telangana", code: "100023" },
    { name: "Uttar Pradesh", code: "100006" },
    { name: "Uttarakhand", code: "100016" },
    { name: "West Bengal", code: "100013" },
    { name: "Goa", code: "100028" },
];


const firmType = [
    { label: "Select Firm Type", value: "0" },
    { label: "Proprietorship", value: "1" },
    { label: "Partnership", value: "2" },
    { label: "Pvt Ltd", value: "3" },
    { label: "Ltd", value: "4" },
    { label: "Trust", value: "5" },
    { label: "Individual", value: "6" },
]

const media = [
    { label: "Fibre", value: "1" },
    { label: "RF", value: "2" },
]
const ExServiceProviderOne = [
    { label: "Select Service Provider 1", value: "0" },
    { label: "Jio", value: "111260000" },
    { label: "ACT Fibernet", value: "569480014" },
    { label: "N.A", value: "569480012" },
    { label: "Others", value: "569480013" },
    { label: "Airtel", value: "569480000" },
    { label: "Aircel", value: "569480002" },
    { label: "BSNL", value: "569480003" },
    { label: "Hathway", value: "569480004" },
    { label: "MTNL", value: "569480005" },
    { label: "Nextra", value: "569480006" },
    { label: "Reliance Communications", value: "569480007" },
    { label: "Sify", value: "569480008" },
    { label: "Tata Communications", value: "569480009" },
    { label: "Tata DOCOMO", value: "569480010" },
    { label: "Tikona Infinet", value: "569480011" },
    { label: "Vodafone", value: "569480001" },
]
const ExServiceProviderTwo = [
    { label: "Select Service Provider 2", value: "0" },
    { label: "Jio", value: "111260000" },
    { label: "ACT Fibernet", value: "569480014" },
    { label: "N.A", value: "569480012" },
    { label: "Others", value: "569480013" },
    { label: "Airtel", value: "569480000" },
    { label: "Aircel", value: "569480002" },
    { label: "BSNL", value: "569480003" },
    { label: "Hathway", value: "569480004" },
    { label: "MTNL", value: "569480005" },
    { label: "Nextra", value: "569480006" },
    { label: "Reliance Communications", value: "569480007" },
    { label: "Sify", value: "569480008" },
    { label: "Tata Communications", value: "569480009" },
    { label: "Tata DOCOMO", value: "569480010" },
    { label: "Tikona Infinet", value: "569480011" },
    { label: "Vodafone", value: "569480001" },
]
const optionDataCenter = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: "true" },
    { label: "No", value: "false" }
]

const optionInterestedVPN = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: "true" },
    { label: "No", value: "false" }
]
const optionServiceFromServiceProvider1 = [
    { label: "Select Existing Service Provider", value: "" },
    { label: "Internet", value: "569480000" },
    { label: "Data Center Services", value: "569480001" },
    { label: "OIP Services", value: "569480002" },
    { label: "Other Services", value: "569480003" }
]

const optionServiceFromServiceProvider2 = [
    { label: "Select Existing Service Provider", value: "" },
    { label: "Internet", value: "569480000" },
    { label: "Data Center Services", value: "569480001" },
    { label: "OIP Services", value: "569480002" },
    { label: "Other Services", value: "569480003" }
]
const ClientProfileOptions = [
    { value: "111260000", label: "Business" },
    { value: "111260001", label: "Leisure" },
    { value: "111260002", label: "International Tourist" },
    { value: "111260003", label: "Mixed" },
]

const PropertyTypeOptions = [
    { value: "111260000", label: "Leased" },
    { value: "111260001", label: "Owned" },
]
const optionInterestedVOIP = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: "true" },
    { label: "No", value: "false" }
]

const optionInterestedManageWiFi = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: "true" },
    { label: "No", value: "false" }
]
const optionFirewall = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: "True" },
    { label: "No", value: "False" }
]
const optionIsMultilocationCust = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: "True" },
    { label: "No", value: "False" }
]
const optionPaymentMode = [
    { label: "Select Option", value: "" },
    { label: "Capex", value: "Capex" },
    { label: "Opex", value: "Opex" }
];
const optionExistingServProvInfra = [
    { label: "Select Option", value: "" },
    { label: "OEM", value: "OEM" },
    { label: "System Integrator", value: "System Integrator" },
    { label: "Other", value: "Other" }
];
const optionQualify = [
    { label: "Irrelevant POC", value: "569480000" },
    { label: "Unable to meet/RNR", value: "569480002" },
    { label: "Not Interested", value: "569480003 " },
    { label: "Using AP based Wi-Fi", value: "569480007 " },
    { label: "Value not Seen", value: "569480008" },
    { label: "Other", value: "other" }
];
const painPointsOptions = [
    { value: "CustommerComplaints", label: "Customer Complaints" },
    { value: "AccessIssuesAuthentication", label: "Access Issues- Authentication " },
    { value: "OutDatedSetup", label: "Outdated Setup" },
    { value: "ServiceSupportChallenges", label: "Service Support Challenges" },
    { value: "LackOfItExpertise", label: "Lack of IT expertise" },
    { value: "UnableToEnhanceExperience", label: "Unable To Enhance Experience" },
    { value: "Other", label: "Others" },
];
const BusinessLeadForm = () => {
    const topicInputRef = useRef(null);
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // This line disable the blue border
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
    };

    const [selectedClientProfile, setSelectedClientProfile] = useState(null);
    const [leadStatus, setLeadStatus] = useState("");
    const [meetingcounter, setmeetingcounter] = useState("");
    const [loaders, setLoaders] = useState(false);
    const [loading, setLoading] = useState(false);
    const [activeForm, setActiveForm] = useState("form1");
    const [userLeadDataRaw, setUseSameDataRaw] = useState({});
    const [userLeadData, setUserLeadData] = useState({
        NoofFloors:"",
        topic: "",
        leadId: "",
        PersonName: "",
        mobileNo: "",
        email: "",
        leadName: "",
        companyName: "",
        specifyBuilding: "",
        specifyBuildingOne: "",
        specifyArea: "",
        specifyAreaOne: "",
        buildingNum: "",
        buildingNumOne: "",
        block: "",
        floor: "",
        pin: "",
        blockOne: "",
        floorOne: "",
        pinOne: "",
        jobTitle: "",
        onFirewall: "",
        howManyLocations: "",
        actualContract: "",
        detailServProvInfra: "",
        targetInstallationPeriod: "",
        contractExpDate: "",
        remark: "",
        noOfFloor: "",
        NoOfCompanies: "",
        FullAddress: "",
        NumberOfIntUser: "",
        SpectraRFS: "",
        specificDesignation: "",
        specificExistingInternetProvider: "",
        existingInternetOutflowOther: ""
    });


    const handleSelectClientProfile = (selectedOption) => {
        setSelectedClientProfile(selectedOption);
        setUserLeadData({
            ...userLeadData,
            ClientProfile: selectedOption ? selectedOption.value : "",
        });
    };

    const handleSelectPropertyType = (selectedOption) => {
        // setSelectedClientProfile(selectedOption);
        setUserLeadData({
            ...userLeadData,
            PropertyType: selectedOption ? selectedOption.value : "",
        });
    };
    const [selectExistingInternetProvider, setSelectExistingInternetProvider] = useState(null);
    const handleSelectExistingInternetProvider = (selectedOption) => {
        setSelectExistingInternetProvider(selectedOption);
        setUserLeadData((prev) => ({
            ...prev,
            existingInternetProvider: selectedOption ? selectedOption.value : "",
        }));
    };

    // Existing Internet Outflow Per Month
    const [selectExistingInternetOutflow, setSelectExistingInternetOutflow] = useState(null);
    const handleSelectExistingInternetOutflow = (selectedOption) => {
        setSelectExistingInternetOutflow(selectedOption);
        setUserLeadData((prev) => ({
            ...prev,
            existingInternetOutflow: selectedOption ? selectedOption.value : "",
        }));
    };



    // Pain Points (multi-select)
    const [selectPainPoints, setSelectPainPoints] = useState([]);
    const handleSelectPainPoints = (selectedOptions) => {
        setSelectPainPoints(selectedOptions);
        setUserLeadData((prev) => ({
            ...prev,
            painPoints: selectedOptions ? selectedOptions.map((option) => option.value) : [],
        }));
    };





    // Role
    const [selectRole, setSelectRole] = useState(null);
    const handleSelectRole = (selectedOption) => {
        setSelectRole(selectedOption);
        setUserLeadData((prev) => ({
            ...prev,
            role: selectedOption ? selectedOption.value : "",
        }));
    };
    const [selectPayment, setselectPayment] = useState(null);
    const handleselectPayment = (selectedOption) => {
        setselectPayment(selectedOption);
        setUserLeadData((prev) => ({
            ...prev,
            paymentTerms: selectedOption ? selectedOption.value : "",
        }));
    };
    const [verticalOptions, setVerticalOptions] = useState([]);
    const [selectedVertical, setSelectedVertical] = useState("");

    const [currentWorkLocations, setCurrentWorkLocations] = useState([]);
    const [selectCurrentWorkLocation, setSelectCurrentWorkLocation] =
        useState("");
    const [selectCity, setSelectCity] = useState("");
    const [cityType, setCityType] = useState([]);
    const [cityTypeOne, setCityTypeOne] = useState([]);
    const [selectCityOne, setSelectCityOne] = useState("");

    const [selectState, setSelectState] = useState("");
    const [selectStateOne, setSelectStateOne] = useState("");
    const [areaList, setAreaList] = useState([]);
    const [selectArea, setSelectArea] = useState("");
    const [selectAreaOne, setSelectAreaOne] = useState("");

    const [buildingList, setBuildingList] = useState([]);
    const [selectBuilding, setSelectBuilding] = useState("");
    const [selectBuildingOne, setSelectBuildingOne] = useState("");
    const [companyOptions, setCompanyOptions] = useState([]);
    const [groupOptions, setGroupOptions] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [leadName, setLeadName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [relationshipOptions, setRelationshipOptions] = useState([]);
    const [selectRelationship, setSelectRelationship] = useState("");
    // const [companyId, setCompanyId] = useState("");
    // const [selectBusiness, setSelectBusiness] = useState("");
    const [selectSubBusiness, setSelectSubBusiness] = useState(optionSubBusiness[0]);
    const [selectCustomerSeg, setSelectCustomerSeg] = useState(optionCustomerSeg[0]);
    const [selectSalutation, setSelectSalutation] = useState(optionSalutation[0]);
    //const [selectGroup, setSelectGroup] = useState("");
    //const [selectRelationship, setSelectRelationship] = useState("");
    const [selectLeadChannel, setSelectLeadChannel] = useState(optionLeadChannel[0]);
    const [selectLeadSource, setSelectLeadSource] = useState("");
    const [leadSourceOptions, setLeadSourceOptions] = useState([]);
    const [selectChannelPartner, setSelectChannelPartner] = useState("");
    const [selectCountry, setSelectCountry] = useState(optionCountry[0]);
    const [selectCountryOne, setSelectCountryOne] = useState(optionCountry[0]);

    const [selectFirmType, setSelectFirmType] = useState(firmType[0]);

    const [industryTypes, setIndustryTypes] = useState([]);
    const [selectIndustryType, setSelectIndustryType] = useState("");

    const [selectMedia, setSelectMedia] = useState(media[0]);
    const [selectProduct, setSelectProduct] = useState();
    const [filterProductName, setFilterProductName] = useState("")
    const [selectProductOption, setSelectProductOption] = useState([]);
    const [selectExServiceProviderOne, setSelectExServiceProviderOne] =
        useState(ExServiceProviderOne[0]);
    const [selectExServiceProviderTwo, setSelectExServiceProviderTwo] =
        useState(ExServiceProviderTwo[0]);
    const [selectDataCenter, setSelectDataCenter] = useState(optionDataCenter[0]);
    const [selectInterestedFirewall, setSelectInterestedFirewall] = useState(optionFirewall[0]);
    const [selectInterestedVPN, setSelectInteretedVPN] = useState(optionInterestedVPN[0]);
    const [selectServiceProviderOne, setSelectServiceProviderOne] = useState(optionServiceFromServiceProvider1[0]);
    const [selectServiceProviderTwo, setSelectServiceProviderTwo] = useState(optionServiceFromServiceProvider2[0]);
    const [selectInterestedVOIP, setSelectInterestedVOIP] = useState(optionInterestedVOIP[0]);
    const [selectInterestedManageWiFi, setSelectInterestedManageWiFi] =
        useState(optionInterestedManageWiFi[0]);
    const [selectFirewall, setSelectFirewall] = useState(optionFirewall[0]);
    const [selectIsMultilocationCust, setSelectIsMultilocationCust] =
        useState(optionIsMultilocationCust[0]);
    const [selectPaymentMode, setSelectPaymentMode] = useState(optionPaymentMode[0]);
    const [selectExistingServProvInfra, setSelectExistingServProvInfra] =
        useState(optionExistingServProvInfra[0]);
    const [useSameData, setUseSameData] = useState(false);
    const [status, setStatus] = useState(null);
    const [flrStatus, setFlrStatus] = useState(null);

    const [comName, setComName] = useState("");
    const [companyId, setCompanyId] = useState("");
    const [getDigiCompanyId, setGetDigiCompanyId] = useState("");
    const [relationShipId, setRelationShipId] = useState("");
    const [getGroup, setGetGroup] = useState("");
    const [getCity, setGetCity] = useState("");


    const [selectTurnOver, setSelectTurnOver] = useState(optionTurnOver[0]);
    const [leadlatitude, setLeadlatitude] = useState();
    const [leadlongitude, setLeadlongitude] = useState();
    const [selectBarrier, setSelectBarrier] = useState(optionBarrier[0]);
    const [selectOfficeArea, setSelectOfficeArea] = useState(optionOfficeArea[0]);
    const [selectExistConnectivity, setSelectExistConnectivity] = useState(optionExistConnectivity[0]);
    const [selectApplications, setSelectApplications] = useState(optionApplications[0]);
    const [selectProductName, setSelectProductName] = useState(optionProductName[0]);
    const [selectDesignation, setSelectDesignation] = useState(optionDesignation[0]);

    const [officeEmpCount, setOfficeEmpCount] = useState("");
    const [optionOfficeEmpCount, setOptionOfficeEmpCount] = useState([]);
    const [coverageAreaRange, setCoverageAreaRange] = useState("");
    const [optionCoverageAreaRange, setOptionCoverageAreaRange] = useState([]);
    const [accessPointsCount, setAccessPointsCount] = useState("");
    const [optionAccessPointsCount, setOptionAccessPointsCount] = useState([]);
    const [productName, setProductName] = useState("");
    const [optionProductNameNew, setOptionProductNameNew] = useState([]);
    const [productCrmId, setProductCrmId] = useState("");


    const [showForm, setShowForm] = useState(false)

    const [selectedReasons, setSelectedReasons] = useState([])





    const handleSelectCoverageAreaRange = (selected) => {
        setCoverageAreaRange(selected);
    };

    const handleSelectOfficeEmpCount = (selected) => {
        setOfficeEmpCount(selected);
        setCoverageAreaRange("")
    };


    const handleSelectDesignation = (selectDesignation) => {
        setSelectDesignation(selectDesignation);
    };

    const handleSelectTurnOver = (selectTurnOver) => {
        setSelectTurnOver(selectTurnOver);
    };

    const handleSelectBarrier = (selected) => {
        setSelectBarrier(selected);
    };


    const handleSelectApplications = (selected) => {
        setSelectApplications(selected);
    };



    const handleSelectSalutation = (selectSalutation) => {
        setSelectSalutation(selectSalutation);
    };
    const handleSelectRelationship = (selectRelationship) => {
        setSelectRelationship(selectRelationship);
    };
    const handleSelectGroup = (selectGroup) => {
        // setGroupOptions(selectGroup);
        setSelectedGroup(selectGroup);
    };
    const handleSelectLeadChannel = (selectLeadChannel) => {
        setSelectLeadChannel(selectLeadChannel);
    };
    const handleSelectLeadSource = (selectLeadSource) => {
        setSelectLeadSource(selectLeadSource);
    };
    const handleSelectChannelPartner = (selectChannelPartner) => {
        setSelectChannelPartner(selectChannelPartner);
    };
    const handleSelectCountry = (selectCountry) => {
        setSelectCountry(selectCountry);
    };
    const handleSelectCountryOne = (selectCountryOne) => {
        // console.log(selectCountryOne);

        setSelectCountryOne(selectCountryOne);
    };
    const handleSelectFirmType = (selectFirmType) => {
        setSelectFirmType(selectFirmType);
    };
    const handleSelectIndustryType = (selectIndustryType) => {
        setSelectIndustryType(selectIndustryType);
    };



    const handleChange = (e) => {
        // console.log(e.target.name, e.target.value);
        setUserLeadData({ ...userLeadData, [e.target.name]: e.target.value });
    };

    const handleChange1 = (e) => {

        // console.log(e.target.name);
        // console.log(e.target.value);
        setUserLeadData({ ...userLeadData, [e.target.name]: isNaN(parseInt(e.target.value, 10)) ? "" : parseInt(e.target.value, 10) });
    };

    const [selectSpectraRelationship, setSelectSpectraRelationship] = useState(null);
    const handleSelectSpectraRelationship = (selectedOption) => {
        setSelectSpectraRelationship(selectedOption);
        setUserLeadData((prev) => ({
            ...prev,
            spectraRelationship: selectedOption ? selectedOption.value : "",
        }));
    };
    const handleCheckboxChange = () => {
        // console.log("checked")
        const newValue = !useSameData;
        setUseSameData(newValue);

        if (newValue) {
            setSelectCountryOne(selectCountry);
            setSelectStateOne(selectState);
            setSelectCityOne(selectCity);
            setSelectAreaOne(selectArea);
            setSelectBuildingOne(selectBuilding);
            setUserLeadData((prevData) => ({
                ...prevData,
                blockOne: prevData.block,
                floorOne: prevData.floor,
                pinOne: prevData.pin,
                buildingNumOne: prevData.buildingNum,
                specifyBuildingOne: prevData.specifyBuilding,
                specifyAreaOne: prevData.specifyArea,
            }));
        } else {

            // Optionally reset the "One" states if needed when unchecked
            setSelectCountryOne('');
            setSelectStateOne('');
            setSelectCityOne('');
            setSelectAreaOne('');
            setSelectBuildingOne('');
            setUserLeadData((prevData) => ({
                ...prevData,
                blockOne: '',
                floorOne: '',
                pinOne: '',
                buildingNumOne: '',
                specifyBuildingOne: '',
                specifyAreaOne: '',
            }));
        }
    };


    // ← this now gets an array of options
    const handleChanged = (options) => {
        setSelectedReasons(options || [])
    }

    const MultiValueRemove = (props) => (
        <RSComponents.MultiValueRemove {...props}>
            <span style={{ color: '#900', fontSize: '16px', lineHeight: '1' }}>×</span>
        </RSComponents.MultiValueRemove>
    )
    // const [showForm,    setShowForm]    = useState(false);
    //   const [selectedReasons, setSelectedReasons] = useState([]);
    const [otherText, setOtherText] = useState("");

    const handleDisqualify = async () => {
        if (!selectedReasons.length) {
            toast.warning('Please pick at least one reason.');
            return;
        }
        // If “Other” is selected, ensure user filled it in
        if (selectedReasons.some(r => r.value === "other") && !otherText.trim()) {
            toast.warning('Please specify the “Other” reason.');
            return;
        }
        // Build the comma-separated list, swapping in the user text for “other”
        const reasonList = selectedReasons
            .map(o => o.value === "other" ? otherText.trim() : o.label)
            .join(', ');

        const payload = {
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            Action: 'leadDisqualify',
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password'),
            LeadID: leadId,
            ReasonForDisqualify: reasonList
        };

        try {
            const res = await fetch(process.env.REACT_APP_API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const data = await res.json();

            if (data.StatusCode === '200' || data.Response?.StatusCode === 200) {
                toast.success('Lead disqualified successfully!', { autoClose: 1500 });
                navigate('/BusinessLeadHotel');
            } else {
                toast.error(data.Response?.Message || data.Message || 'Failed to disqualify');
            }
        } catch (err) {
            console.error(err);
            toast.error('Network error, please try again.');
        }
    };
    // const handleDisqualify = async () => {
    //     if (!selectedReasons.length) {
    //         toast.warning('Please pick at least one reason.')
    //         return
    //     }

    //     const reasonList = selectedReasons.map(o => o.label).join(', ')
    //     const apiUrl = process.env.REACT_APP_API_URL;
    //     const payload = {
    //         Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //         Action: 'leadDisqualify',           // ← your new API action
    //         userName: sessionStorage.getItem('userName'),
    //         password: sessionStorage.getItem('password'),
    //         LeadID: leadId,                   // fixed key name
    //         ReasonForDisqualify: reasonList
    //     }

    //     try {
    //         const res = await fetch(apiUrl, {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify(payload),
    //         })
    //         const data = await res.json()

    //         if (data.StatusCode === '200' || data.Response?.StatusCode === 200) {
    //             toast.success('Lead disqualified successfully!', {
    //                 position: toast.POSITION.BOTTOM_CENTER,
    //                 autoClose: 1500,
    //             })
    //             navigate('/BusinessLeadHotel')
    //         } else {
    //             toast.error(data.Response?.Message || data.Message || 'Failed to disqualify')
    //         }
    //     } catch (err) {
    //         console.error(err)
    //         toast.error('Network error, please try again.')
    //     }
    // };

    const fetchCompanyData = async () => {
        try {
            setLoaders(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "getCompany",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                companyId: "New Company",
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });
            const data = await response.json();
            //console.log("conpany name :", data.Response.Data);
            if (data.Status === "Success" && data.StatusCode === "200") {
                // return data.Response.Data.map((company) => ({
                //   label: `${company.Company_Name} (${company.Company_ID})`,
                //   value: company.Company_ID,
                //   group: `${company.Group_Name} (${company.Group_ID})`,
                //   groupId: company.Group_ID,
                // }));
                return data.Response.Data.map((company) => ({
                    label: company.Company_Name,
                    value: company.Company_ID,
                    group: company.Group_Name,
                    groupId: company.Group_ID,
                }));
            } else {
                console.error("Error in API response:", data);
                return [];
            }
        } catch (error) {
            console.error("Error fetching company data:", error);
        } finally {
            setLoaders(false);
        }
        return [];
    };

    const fetchRelationshipData = async (companyId) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "getRelationship",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                companyId: companyId,
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });
            const data = await response.json();
            if (data.Status === "Success" && data.StatusCode === "200") {
                return data.Response.Data.map((relationship) => ({
                    label: relationship.Relationship_Name,
                    value: relationship.Relationship_ID,
                }));
            } else {
                console.error("Error in API response:", data);
                return [];
            }
        } catch (error) {
            console.error("Error fetching relationship data:", error);
        }
        return [];
    };

    useEffect(() => {
        const loadOptions = async () => {
            const options = await fetchCompanyData("");
            let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(userLeadData.companyName || "New Company"));
            // console.log(options, defaultCompanyGroupObj);
            // console.log(userLeadData.companyName);



            // setSelectedCompany({
            //   value: defaultCompanyGroupObj?.value,
            //   label:defaultCompanyGroupObj?.label,
            // });

            // setSelectedGroup({
            //   value: defaultCompanyGroupObj?.groupId,
            //   label:defaultCompanyGroupObj?.group,
            // });

            //   if(relationshipOptions?.length > 0){
            //   let defaultRelationshipObj = relationshipOptions?.find((relationship) => relationship.value == userLeadDataRaw?.RelationshipId);
            //   setSelectRelationship(defaultRelationshipObj);
            // }

            setCompanyOptions(options);

        };
        loadOptions();
    }, []);



    useEffect(() => {
        // Update group options when selectedCompany changes
        if (selectedCompany) {
            setGroupOptions([
                { label: selectedCompany.group, value: selectedCompany.groupId },
            ]);
            // setLeadName(selectedCompany.label); // Automatically set leadName to the selected company name
            //setCompanyId(selectedCompany.companyId); // Set the selected company ID
        } else {
            setGroupOptions([]);
            // setLeadName(""); // Reset leadName when no company is selected
            //setCompanyId(""); // Reset companyId when no company is selected
        }
    }, [selectedCompany]); // Only trigger the effect when selectedCompany changes

    useEffect(() => {
        const loadRelationships = async () => {
            if (selectedCompany) {
                const relationshipOptions = await fetchRelationshipData(
                    selectedCompany.value
                );
                setRelationshipOptions(relationshipOptions);
                // console.log(relationshipOptions);

                setSelectRelationship(relationshipOptions.find((relation) => relation.value == relationShipId))
            }
        };
        loadRelationships();
    }, [selectedCompany]);

    const handleCompanyChange = (selectedOption) => {
        // console.log("selectedOption", selectedOption);
        setSelectedCompany(selectedOption);
        setSelectedGroup(null);
        setSelectRelationship(null)
        //setCompanyId(selectedOption ? selectedOption.value : "");
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = process.env.REACT_APP_API_URL_3;
                const RequestBody = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getBBDIAEmpCount",
                }
                const Response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(RequestBody),
                });
                const data = await Response.json();
                // console.log("data", data);

                if (data.Response) {
                    const options = data.Response.map(
                        (option) => ({
                            label: option.office_employee_count,
                            value: option.office_employee_count_id,
                        })
                    );
                    setOptionOfficeEmpCount(options);

                } else {
                    setOptionOfficeEmpCount([])
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);


    useEffect(() => {
        if (!officeEmpCount?.value) return;
        const fetchCoverageAreaRange = async () => {
            try {
                const url = process.env.REACT_APP_API_URL_3;
                const RequestBody = {
                    "Action": "getBBDIAOffArea",
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "empCount": officeEmpCount.value
                }
                const Response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(RequestBody),
                });
                const data = await Response.json();
                // console.log("data", data);

                if (data.Response) {
                    const options = data.Response.map(
                        (option) => ({
                            label: option.coverage_area_range,
                            value: option.coverage_area_range_id,
                        })
                    );
                    setOptionCoverageAreaRange(options);
                } else {
                    setOptionCoverageAreaRange([])
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchCoverageAreaRange();
    }, [officeEmpCount]);







    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const leadId = searchParams.get("LeadId");
    // console.log(leadId);
    const ContactId = searchParams.get("ContactId");

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getLeads",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    ContactId: ContactId ? ContactId : "",
                    LeadId: leadId ? leadId : "",
                    // "LeadId": "L-03-2025-281358",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName')
                }
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });
                const data = await response.json();
                // console.log("getLeads", data);
                const responseData = data.Response[0]
                const concatenatedAddress = `${responseData.installationAddress.InstallBuildingName || ''} 
                                 ${responseData.installationAddress.InstallAreaName || ''} ${responseData.installationAddress.InstallCityName || ''} ${responseData.installationAddress.InstallStateName || ''} ${responseData.installationAddress.InstallCountryName || 'India'}`;
                const pgInfo = data.Response[0]?.PgInfo;
                const apiData = data.Response[0]?.HotelInfo;
                setUserLeadData({
                    topic: data.Response[0]?.LeadTopic,
                    leadId: data.Response[0]?.LeadId,
                    PersonName: data.Response[0]?.ContactPersonName,
                    mobileNo: data.Response[0]?.MobileNo,
                    email: data.Response[0]?.EmailId,
                    leadName: data.Response[0]?.FirstName,
                    companyName: data.Response[0]?.CompanyNameCompany,
                    buildingNum: data.Response[0]?.installationAddress.InstallPlotNo,
                    buildingNumOne: data.Response[0]?.contactAddress.ContactPlotNo,
                    specifyBuilding:
                        data.Response[0]?.installationAddress.InstallSpecifyBuilding,
                    specifyBuildingOne:
                        data.Response[0]?.contactAddress.ContactSpecifyBuilding,
                    specifyArea: data.Response[0]?.installationAddress.InstallSpecifyArea,
                    specifyAreaOne: data.Response[0]?.contactAddress.ContactSpecifyArea,
                    block: data.Response[0]?.installationAddress.Block,
                    floor: data.Response[0]?.installationAddress.InstallFloor,
                    pin: data.Response[0]?.installationAddress.InstallPincode,
                    blockOne: data.Response[0]?.contactAddress.ContactBlock,
                    floorOne: data.Response[0]?.contactAddress.ContactFloor,
                    pinOne: data.Response[0]?.contactAddress.ContactPincode,
                    jobTitle: data.Response[0]?.companyDetail.JobTitle,
                    onFirewall: data.Response[0]?.otherDetail.SpendOnFirewall,
                    howManyLocations: data.Response[0]?.otherDetail.HowManyLocations,
                    setSelectPaymentMode: data.Response[0]?.otherDetail.PaymentMode,
                    actualContract: data.Response[0]?.otherDetail.ActualContract,
                    detailServProvInfra: data.Response[0]?.otherDetail.DetailServProvInfra,
                    targetInstallationPeriod:
                        data.Response[0]?.otherDetail.TargetInstallationPeriod,
                    contractExpDate: data.Response[0]?.otherDetail.ContractExpDate,
                    remark: data.Response[0]?.Remark,
                    pgName: pgInfo?.PGName,

                    numberOfRooms: pgInfo?.NumberofRooms,
                    numberOfBeds: pgInfo?.NumberofBeds,
                    perBedRent: pgInfo?.PerBedRent,
                    googleRatings: pgInfo?.GoogleRatings,
                    hotelInternetRatings: pgInfo?.PGInternetRatings,


                    specificDesignation: pgInfo?.DesignationOthers,
                    specificExistingInternetProvider: pgInfo?.ExistingInternetProviderOther,
                    existingInternetOutflowOther: pgInfo?.ExistingInternetOutflowPerMonthOther,


                    SpectraRFS: pgInfo?.SpectraRFS,
                    noOfFloor: "",
                    NoOfCompanies: "",
                    FullAddress: "",
                    NumberOfIntUser: pgInfo?.NumberofInternetUsers,

                    // For select/dropdown values, we store the value (you can also store the whole option if preferred)
                    pgType: pgInfo?.PGType,
                    tenantType: pgInfo?.TenantType,
                    existingInternetProvider: pgInfo?.ExistingInternetProvider,
                    existingInternetOutflow: pgInfo?.ExistingInternetOutflowPerMonth,
                    currentInfra: pgInfo?.CurrentInfra,
                    urgentTriggers: pgInfo?.UrgentTriggers,
                    spectraRelationship: pgInfo?.SpectraRelationship,
                    role: pgInfo?.Role,
                    paymentTerms: pgInfo?.PaymentTerms,
                    numberOfRooms: apiData?.NumberOfRooms || "",

                    DetailsofTVsCCTVIOT: apiData.DetailsOfTvsCctvIot,
                    ClientProfile: apiData.ClientProfile,
                    PropertyType: apiData.TypeOfProperty,
                    LeasePeriod: apiData.DurationOfLease,
                    DailyRoomRent: apiData.DailyRoomRentAvg,
                    NoofFloors: apiData.NoOfFloors,
                    RoomsPerFloor: apiData.RoomsPerFloor,
                    PpOthers: apiData.PpOthers,

                    // For pain points, create an array based on boolean "1" values
                    painPoints: [
                        apiData.CustommerComplaints === "1" && "CustommerComplaints",
                        apiData.AccessIssuesAuthentication === "1" && "AccessIssuesAuthentication",
                        apiData.OutDatedSetup === "1" && "OutDatedSetup",
                        apiData.ServiceSupportChallenges === "1" && "ServiceSupportChallenges",
                        apiData.LackOfItExpertise === "1" && "LackOfItExpertise",
                        apiData.UnableToEnhanceExperience === "1" && "UnableToEnhanceExperience",
                        apiData.Other === "1" && "Other",

                    ].filter(Boolean),
                });
                setLeadStatus(data.Response[0]?.Status)
                setGetCity(data.Response[0]?.installationAddress.InstallCityName);
                setComName(data.Response[0]?.companyDetail.CompanyName)
                setCompanyId(data.Response[0]?.CompanyId);
                setRelationShipId(data.Response[0]?.RelationshipId)
                setGetGroup(data.Response[0]?.GroupId);
                setUseSameDataRaw(data?.Response[0])
                let relationshipOptions1
                if (data.Response[0]?.CompanyId) {
                    relationshipOptions1 = await fetchRelationshipData(
                        data.Response[0]?.CompanyId
                    );
                    // console.log("relationshipOptions1",relationshipOptions1);
                    setRelationshipOptions(relationshipOptions1);
                }
                // const verticalId = data.Response[0]?.VerticalID || "";
                // Find matching option from verticalOptions
                // const selectedVerticalOption = verticalOptions?.find(option => option?.value === verticalId) || null;
                // Update state
                // setSelectedVertical(selectedVerticalOption);
                setCompanyName(pgInfo?.PGName,);
                setmeetingcounter(pgInfo?.MeetingCounter);

                setLeadlatitude(pgInfo?.Latitude);
                setLeadlongitude(pgInfo?.Longitude);

                const filterIndustryType = industryTypes.find(item => item.value === String(data.Response[0]?.companyDetail.IndustryType)).label;
                setSelectIndustryType(
                    {
                        value: data.Response[0].companyDetail.IndustryType,
                        label: filterIndustryType ? filterIndustryType : "",

                    });

                // console.log("12345678", pgInfo.PaymentTerms);
                const filterfirmType = firmType?.find(item => item.value === String(data.Response[0].companyDetail.FirmType)).label;
                setSelectFirmType(
                    {
                        value: data.Response[0]?.companyDetail.FirmType,
                        label: filterfirmType ? filterfirmType : "",
                    });

                const existingInternetProviderOption =
                    internetProviderOptions?.find((opt) => opt.value === pgInfo.ExistingInternetProvider) || null;
                setSelectExistingInternetProvider(existingInternetProviderOption);

                const existingInternetOutflowOption =
                    internetOutflowOptions?.find((opt) => opt.value === pgInfo.ExistingInternetOutflowPerMonth) || null;
                setSelectExistingInternetOutflow(existingInternetOutflowOption);

                setSelectSpectraRelationship(
                    spectraRelationshipOptions.find(option => option.value === pgInfo.SpectraRelationship) || null
                );


                const filterBarrierId = optionBarrier?.find(item => item.value == String(data.Response[0]?.PgInfo.Barriers))?.label;
                if (filterBarrierId) {
                    setSelectBarrier({
                        value: data.Response[0]?.PgInfo.Barriers,
                        label: filterBarrierId,
                    });
                }

                const filterOfficeArea = optionOfficeArea?.find(item => item.value == String(data.Response[0]?.PgInfo.OfficeArea))?.label;
                if (filterOfficeArea) {
                    setSelectOfficeArea({
                        value: data.Response[0]?.PgInfo.OfficeArea,
                        label: filterOfficeArea,
                    });
                }
                // console.log("optionExistConnectivity", data.Response[0]?.PgInfo.ExistingConnectivity);
                const filterTurnOver = optionTurnOver?.find(item => item.value == String(data.Response[0]?.PgInfo.CompanyTurnover))?.label;
                if (filterTurnOver) {
                    setSelectTurnOver({
                        value: data.Response[0]?.PgInfo.CompanyTurnover,
                        label: filterTurnOver,
                    });
                }

                const filterDesignation = optionDesignation?.find(item => item.value == String(data.Response[0]?.PgInfo.Designation))?.label;
                if (filterDesignation) {
                    setSelectDesignation({
                        value: data.Response[0]?.PgInfo.Designation,
                        label: filterDesignation,
                    });
                }

                const filterExistCon = optionExistConnectivity?.find(item => item.value == String(data.Response[0]?.PgInfo.ExistingConnectivity))?.label;
                if (filterExistCon) {
                    setSelectExistConnectivity({
                        value: data.Response[0]?.PgInfo.ExistingConnectivity,
                        label: filterExistCon,
                    });
                }
                const filterApplications = optionApplications?.find(item => item.value == String(data.Response[0]?.PgInfo.Applications))?.label;
                if (filterApplications) {
                    setSelectApplications({
                        value: data.Response[0]?.PgInfo.Applications,
                        label: filterApplications,
                    });
                }
                const filteEmployeeCount = optionOfficeEmpCount?.find(item => item.value == String(data.Response[0]?.PgInfo.EmployeeCount))?.label;
                if (filteEmployeeCount) {
                    setOfficeEmpCount({
                        value: data.Response[0]?.PgInfo?.EmployeeCount,
                        label: filteEmployeeCount,
                    })
                }
                const officeArea = await api.getBBDIAOffArea(data.Response[0]?.PgInfo.EmployeeCount);

                const officeAreaOptionSet = officeArea?.Response?.map(item => ({
                    value: item.coverage_area_range_id,
                    label: item.coverage_area_range
                }));

                // console.log("getOpp officeAreaOptionSet: ", officeAreaOptionSet, pgInfo.OfficeArea);
                setCoverageAreaRange(officeAreaOptionSet.find(item => item.value == data.Response[0]?.PgInfo?.OfficeArea) || null)

                const paymentoption = paymentoptions.find((opt) => opt.value === pgInfo.PaymentTerms) || null;
                setselectPayment(paymentoption);

                setSelectLeadChannel(
                    {
                        value: data.Response[0] ? data.Response[0].LeadChannel : "",
                        label: data.Response[0] ? data.Response[0].LeadChannel : "",
                    });
                setSelectLeadSource(
                    {
                        value: data.Response[0]?.LeadSource,
                        label: data.Response[0]?.LeadSource,
                    });
                setLeadName(data.Response[0]?.FirstName);

                setSelectCountry(
                    {
                        value: data.Response[0]?.installationAddress.InstallCountry,
                        label: data.Response[0]?.installationAddress.InstallCountryName,
                    });
                setSelectState(
                    {
                        value: data.Response[0]?.installationAddress.InstallState,
                        label: data.Response[0]?.installationAddress.InstallStateName,
                    });
                setSelectCity(
                    {
                        value: data.Response[0]?.installationAddress ? data.Response[0].installationAddress.InstallCity : "",
                        label: data.Response[0]?.installationAddress ? data.Response[0].installationAddress.InstallCityName : "",
                    });
                setSelectCountryOne(
                    {
                        value: data.Response[0]?.contactAddress.ContactCountry,
                        label: data.Response[0]?.contactAddress.ContactCountryName,
                    });
                setSelectStateOne(
                    {
                        value: data.Response[0]?.contactAddress.ContactState,
                        label: data.Response[0]?.contactAddress.ContactStateName,
                    });
                setSelectCityOne(
                    {
                        value: data.Response[0]?.contactAddress.ContactCity,
                        label: data.Response[0]?.contactAddress.ContactCityName,
                    });
                setSelectArea({
                    value: data.Response[0]?.installationAddress.InstallArea,
                    label: data.Response[0]?.installationAddress.InstallArea && data.Response[0]?.installationAddress.InstallArea ?
                        `${data.Response[0]?.installationAddress.InstallAreaName} (${data.Response[0]?.installationAddress.InstallArea})` : "",
                });
                setSelectAreaOne({
                    value: data.Response[0]?.contactAddress.ContactArea,
                    label: data.Response[0]?.contactAddress.ContactArea && data.Response[0]?.contactAddress.ContactAreaName ?
                        `${data.Response[0]?.contactAddress.ContactAreaName} (${data.Response[0]?.contactAddress.ContactArea})` : "",
                });
                setSelectBuilding({
                    value: data.Response[0]?.installationAddress.InstallBuilding,
                    label: data.Response[0]?.installationAddress.InstallBuilding && data.Response[0].installationAddress.InstallBuildingName ? `${data.Response[0].installationAddress.InstallBuildingName} (${data.Response[0].installationAddress.InstallBuilding})` : "",
                });
                setSelectBuildingOne({
                    value: data.Response[0]?.contactAddress.ContactBuilding,
                    label: data.Response[0]?.contactAddress.ContactBuilding && data.Response[0]?.contactAddress.ContactBuildingName ? `${data.Response[0]?.contactAddress.ContactBuildingName} (${data.Response[0].contactAddress.ContactBuilding})` : "",
                });
                fetchLatLong(concatenatedAddress);

                const filterProductname = optionProductNameNew?.find(item => item.value == String(data.Response[0]?.PgInfo.ProductName))?.label;
                if (filterProductname) {
                    setProductName({
                        value: data.Response[0]?.PgInfo.ProductName,
                        label: filterProductname,
                    });
                }


                const filterSalutationId = optionSalutation?.find(item => item.value === String(data.Response[0]?.SalutationId))?.label;
                setSelectSalutation(
                    {
                        value: data.Response[0]?.SalutationId,
                        label: filterSalutationId ? filterSalutationId : "",
                    });




                // For pain points, build an array of select options
                const painPointOptions = [];

                if (apiData.AccessIssuesAuthentication === "1")
                    painPointOptions.push({ value: "AccessIssuesAuthentication", label: "Access issues Authentication" });
                if (apiData.UnableToEnhanceExperience === "1")
                    painPointOptions.push({ value: "UnableToEnhanceExperience", label: "Unable To Enhance Experience" });
                if (apiData.LackOfItExpertise === "1")
                    painPointOptions.push({ value: "LackOfItExpertise", label: "Lack Of It Expertise" });
                if (apiData.OutDatedSetup === "1")
                    painPointOptions.push({
                        value: "OutDatedSetup",
                        label: "Out dated Setup",
                    });
                if (apiData.ServiceSupportChallenges === "1")
                    painPointOptions.push({ value: "ServiceSupportChallenges", label: "Service Support Challenges" });
                if (apiData.CustommerComplaints === "1")
                    painPointOptions.push({ value: "CustommerComplaints", label: "Customer Complaints" });
                if (apiData.Other === "1")
                    painPointOptions.push({ value: "Other", label: "Others" });
                setSelectPainPoints(painPointOptions);



                const roleOption = roleOptions.find((opt) => opt.value === pgInfo.Role) || null;
                setSelectRole(roleOption);

                // setSelectBusiness(data.Response[0].BusinessSegment);
                if (data.Response[0].IsSameAddress == 1) {
                    setUseSameData(true);
                } else {
                    setUseSameData(false);
                }
                // setUseSameData(data.Response[0].IsSameAddress)
                setStatus(data.Response[0].Status);
                setFlrStatus(data.Response[0].FLRstatus);
                // setSelectSubBusiness(data.Response[0].installationAddress.InstallStateName);
                // const filterSubBusinessSegment = optionSubBusiness.find(item => item.value === String(data.Response[0].SubBusinessSegment)).label;
                setSelectSubBusiness(
                    {
                        value: data.Response[0].SubBusinessSegment,
                        label: data.Response[0].SubBusinessSegment,
                    })

                setSelectedCompany({
                    label: `${data.Response[0].CompanyNameCompany}`,
                    value: data.Response[0].CompanyId,
                    group: data.Response[0].GroupName,
                    groupId: data.Response[0].GroupId,
                });

                setSelectedGroup({
                    label: data.Response[0].GroupName,
                    value: data.Response[0].GroupId,
                });

                setSelectChannelPartner(data.Response[0].ChannelPartner);






                const relationshipId = data.Response[0].RelationshipId;
                const filterRelationshipId = relationshipOptions1 ? relationshipOptions1.find(item => String(item.value) === String(relationshipId)) : null;
                // console.log("filterRelationshipId",filterRelationshipId);
                // if (filterRelationshipId) {
                //   setSelectRelationship({
                //     value: filterRelationshipId ? filterRelationshipId.value : "",
                //     label: filterRelationshipId ? filterRelationshipId.label : "",
                //   });
                // } else {
                //   console.error("RelationshipId not found in relationshipOptions");
                // }

            } catch (error) {
                //console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();

    }, [leadId, industryTypes, ContactId, selectProductOption]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Industry API call
                const industryTypeApiUrl = process.env.REACT_APP_API_URL;
                const industryTypeRequestBody = {
                    Action: "getindustrytype",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    areaCode: "",
                    areaName: "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };
                const industryTypeResponse = await fetch(industryTypeApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(industryTypeRequestBody),
                });
                const industryTypeData = await industryTypeResponse.json();
                // setIndustryTypes(industryTypeData.Response);
                // console.log("industryTypeData :",industryTypeData.Response)
                if (industryTypeData.Response) {
                    const transformedOptions = industryTypeData.Response.map(
                        (option) => ({
                            label: option.IndTypeName,
                            value: option.IndTypeId,
                        })
                    );
                    const updatedtransformedOptions = transformedOptions.filter(item => !['IND_0073_ID','IND_0072_ID','IND_0074_ID','IND_0068_ID'].includes(item.value));
                    setIndustryTypes(updatedtransformedOptions);
                    // console.log("transformedOptions",transformedOptions)
                } else {
                    setIndustryTypes([]);
                }

                const CityApiUrl = process.env.REACT_APP_API_URL;
                const CityRequestBody = {
                    Action: "getCity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    password: sessionStorage.getItem('password'),
                    stateCode: "0",
                    userName: sessionStorage.getItem('userName'),
                };
                const CityResponse = await fetch(CityApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(CityRequestBody),
                });
                const CityData = await CityResponse.json();
                //console.log(CityData.Response.Data)
                // setCurrentWorkLocations(CityData.Response.Data);
                // if (CityData.Response && Array.isArray(CityData.Response.Data)) {
                //   setCurrentWorkLocations(CityData.Response.Data);
                // }
                if (CityData.Response.Data) {
                    const filteredCities = CityData.Response.Data.filter(
                        (city) => city.IsOperationalCity === true
                    );
                    const transformedOptions = filteredCities.map(
                        (option) => ({
                            label: option.CityName,
                            value: option.CityCode,
                        })
                    );
                    setCurrentWorkLocations(transformedOptions);
                } else {
                    setCurrentWorkLocations([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // lead source API call
                const leadSourceApiUrl = process.env.REACT_APP_API_URL;
                const leadSourceRequestBody = {
                    Action: "getSource",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    channelName: selectLeadChannel.value,
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };
                const leadSourceResponse = await fetch(leadSourceApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(leadSourceRequestBody),
                });
                const leadSourceData = await leadSourceResponse.json();
                // console.log("lead Source :", leadSourceData.Response.Data);
                // Check if data is not undefined or null before mapping
                if (leadSourceData.Response.Data) {
                    // Transforming data into the required format
                    const transformedOptions = leadSourceData.Response.Data.map(
                        (option) => ({
                            label: option.SourceName,
                            value: option.SourceName,
                        })
                    );
                    // console.log("setLeadSourceOptions",transformedOptions)
                    setLeadSourceOptions(transformedOptions);
                } else {
                    // If data is undefined or null, set leadSourceOptions to an empty array
                    setLeadSourceOptions([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [selectLeadChannel]);

    useEffect(() => {
        const fetchProductData = async () => {
            try {
                const productNameUrl = process.env.REACT_APP_API_URL;
                const productNameRequestBody = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getProductLead",
                    "bussSegment": "Business",
                    "password": sessionStorage.getItem('password'),
                    "userName": sessionStorage.getItem('userName'),
                }
                const productNameResponse = await fetch(productNameUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(productNameRequestBody),
                });
                const productNameData = await productNameResponse.json();
                // console.log("productNameData", productNameData);
                setSelectProductOption(productNameData.Response.Data);

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchProductData();
    }, []);

    const handleSelectCity = async (selectedOption) => {
        const selectedCityCode = selectedOption ? selectedOption.value : "";
        const selectedCityName = selectedOption ? selectedOption.label : "";
        // console.log("selectedCityCode", selectedOption.value);
        // console.log("selectedCityName", selectedOption.label);
        setSelectCity(selectedOption);
        setSelectArea("");
        setSelectBuilding("");
        try {
            const areaApiUrl = process.env.REACT_APP_API_URL;
            const areaRequestBody = {
                Action: "getArea",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                cityCode: selectedCityCode,
                cityName: selectedCityName,
                password: sessionStorage.getItem('password'),
                restrictedarea: false,
                stateCode: "",
                userName: sessionStorage.getItem('userName'),
            };
            const areaResponse = await fetch(areaApiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(areaRequestBody),
            });
            const areaData = await areaResponse.json();
            if (areaData.Response && Array.isArray(areaData.Response.Data)) {
                // console.log("area :", areaData.Response.Data);
                setAreaList(areaData.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching area data:", error);
        }
    };

    const handleSelectCityOne = async (selectedOption) => {
        const selectedCityCode = selectedOption ? selectedOption.value : "";
        const selectedCityName = selectedOption ? selectedOption.label : "";
        // console.log("selectedCityCode", selectedOption.value);
        // console.log("selectedCityName", selectedOption.label);
        setSelectCityOne(selectedOption);
        setSelectAreaOne("");
        setSelectBuildingOne("");
        try {
            const areaApiUrl = process.env.REACT_APP_API_URL;
            const areaRequestBody = {
                Action: "getArea",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                cityCode: selectedCityCode,
                cityName: selectedCityName,
                password: sessionStorage.getItem('password'),
                restrictedarea: false,
                stateCode: "",
                userName: sessionStorage.getItem('userName'),
            };
            const areaResponse = await fetch(areaApiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(areaRequestBody),
            });
            const areaData = await areaResponse.json();
            if (areaData.Response && Array.isArray(areaData.Response.Data)) {
                // console.log("area :", areaData.Response.Data);
                setAreaList(areaData.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching area data:", error);
        }
    };

    const handleSelectState = (selectedState) => {
        setSelectState(selectedState);
        setSelectCity("");
        setSelectArea("");
        setSelectBuilding("");
    };

    const handleSelectStateOne = (selectedStateOne) => {
        setSelectStateOne(selectedStateOne);
        setSelectCityOne("");
        setSelectAreaOne("");
        setSelectBuildingOne("");
    };

    useEffect(() => {
        const fetchCities = async () => {
            try {
                // City API call
                const cityApiUrl = process.env.REACT_APP_API_URL;
                const cityRequestBody = {
                    Action: "getCity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    password: sessionStorage.getItem('password'),
                    stateCode: selectState.value,
                    userName: sessionStorage.getItem('userName'),
                };
                const cityResponse = await fetch(cityApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(cityRequestBody),
                });
                const cityData = await cityResponse.json();

                if (cityData.Response && Array.isArray(cityData.Response.Data)) {
                    const filteredCities = cityData.Response.Data.filter(
                        (city) => city.IsOperationalCity === true
                    );
                    setCityType(filteredCities);
                    setCityTypeOne(filteredCities);
                } else {
                    // console.error(
                    //   "City data structure not recognized:",
                    //   cityData.Response
                    // );
                    setCityType([]);
                    setCityTypeOne([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        // Fetch cities only if a state is selected
        if (selectState) {
            fetchCities();
        }
    }, [selectState]);

    useEffect(() => {
        const fetchCities = async () => {
            try {
                // City API call
                const cityApiUrl = process.env.REACT_APP_API_URL;
                const cityRequestBody = {
                    Action: "getCity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    password: sessionStorage.getItem('password'),
                    stateCode: selectStateOne.value,
                    userName: sessionStorage.getItem('userName'),
                };
                const cityResponse = await fetch(cityApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(cityRequestBody),
                });
                const cityData = await cityResponse.json();

                if (cityData.Response && Array.isArray(cityData.Response.Data)) {
                    const filteredCities = cityData.Response.Data.filter(
                        (city) => city.IsOperationalCity === true
                    );
                    setCityTypeOne(filteredCities);
                } else {
                    // console.error(
                    //   "City data structure not recognized:",
                    //   cityData.Response
                    // );

                    setCityTypeOne([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        // Fetch cities only if a state is selected
        if (selectStateOne) {
            fetchCities();
        }
    }, [selectStateOne]);

    const handleSelectArea = async (selectedOption) => {
        setSelectArea(selectedOption);
        setSelectBuilding("");
        const areaCode = selectedOption.value;
        const areaName = selectedOption.label.split(" ")[0];
        try {
            const buildingApiUrl = process.env.REACT_APP_API_URL;
            const buildingRequestBody = {
                Action: "getBuilding",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                areaCode: areaCode,
                areaName: areaName,
                password: sessionStorage.getItem("password"),
                userName: sessionStorage.getItem("userName"),
            };

            const buildingResponse = await fetch(buildingApiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(buildingRequestBody),
            });
            const buildingData = await buildingResponse.json();
            if (buildingData.Response && Array.isArray(buildingData.Response.Data)) {
                setBuildingList(buildingData.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching building data:", error);
        }
    };

    const handleSelectAreaOne = async (selectedOption) => {
        setSelectAreaOne(selectedOption);
        setSelectBuildingOne("");
        const areaCode = selectedOption.value;
        const areaName = selectedOption.label.split(" ")[0];
        try {
            const buildingApiUrl = process.env.REACT_APP_API_URL;
            const buildingRequestBody = {
                Action: "getBuilding",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                areaCode: areaCode,
                areaName: areaName,
                password: sessionStorage.getItem("password"),
                userName: sessionStorage.getItem("userName"),
            };

            const buildingResponse = await fetch(buildingApiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(buildingRequestBody),
            });
            const buildingData = await buildingResponse.json();
            if (buildingData.Response && Array.isArray(buildingData.Response.Data)) {
                setBuildingList(buildingData.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching building data:", error);
        }
    };



    const fetchLatLong = async (address) => {
        try {
            // Prepare API payload
            const payload = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "getLatLong",
                address: address
            };

            // Send API request
            const response = await fetch(process.env.REACT_APP_API_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (result?.Status === "Success") {
                // console.log("Latitude and Longitude fetched successfully:", result);
                // setLeadlatitude(result.Response.latitude);
                // setLeadlongitude(result.Response.longitude);
                // You can handle the successful response here
            } else {
                console.error("Failed to fetch Latitude and Longitude:", result);
                // Handle failure here
            }
        } catch (error) {
            console.error("Error fetching Latitude and Longitude:", error);
            // Handle error here
        }
    };


    const [position, setPosition] = useState({ latitude: null, longitude: null });

    // const getLocation = () => {
    //     if ("geolocation" in navigator) {
    //         navigator.geolocation.getCurrentPosition(function (position) {
    //             setPosition({
    //                 latitude: position.coords.latitude,
    //                 longitude: position.coords.longitude,
    //                 message: "Location Captured",
    //             });
    //         });
    //     } else {
    //         // console.log("Geolocation is not available in your browser.");
    //         toast.warning("location is not available in your browser.", {
    //             position: toast.POSITION.BOTTOM_CENTER,
    //             autoClose: 1500,
    //         });
    //     }
    //     console.log("area :", position)
    // };


    const getLocation = () => {
        // Check if served over HTTPS (geolocation doesn't work over HTTP in production)
        if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
            toast.error("Location access requires HTTPS. Please use a secure connection.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
            });
            return;
        }

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    setPosition({
                        latitude: pos.coords.latitude,
                        longitude: pos.coords.longitude,
                        message: "Location Captured",
                    });
                },
                (error) => {
                    console.error("Geolocation error:", error);
                    toast.error("Unable to retrieve location. Please check browser permissions.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                }
            );
        } else {
            toast.warning("Geolocation is not supported by this browser.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
            });
        }
    };

    useEffect(() => {
        if (position.latitude && position.longitude) {
            // console.log("Updated position:", position);
        }
    }, [position]);

    useEffect(() => {
        getLocation();
    }, []);








    const formatDateString = (dateString) => {
        if (!dateString || dateString.includes("undefined")) {
            return ""; // Return empty string if undefined or malformed
        }
        if (leadId === null) {
            return dateString;
        } else if (dateString.indexOf("-") === 4) {
            return dateString;
        } else if (dateString.indexOf("-") === 2) {
            const [day, month, year] = dateString.split("-");
            return `${year}-${month}-${day}`;
        } else {
            // Assuming dateString is in the format DD-MM-YYYY
            const [day, month, year] = dateString.split("-");
            return `${year}-${month}-${day}`;
        }
    };

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = `${today.getMonth() + 1}`.padStart(2, "0");
        const day = `${today.getDate()}`.padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const handleSubmit = async () => {
        // console.log(selectCity, companyName);
        if (selectSalutation.value === "0") {
            toast.warning("Please Select Salutation", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        else if (!userLeadData.PersonName) {
            toast.warning("Please Enter Contact Person Name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!userLeadData.email) {
            toast.warning("Please Enter Email Id", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userLeadData.email)
        ) {
            toast.warning("Invalid Email Address.Please enter a valid email.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (userLeadData.mobileNo.length < 10) {
            toast.warning("Please Enter Mobile Number", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }

        else if (!userLeadData.NoofFloors) {
            // console.log("!@#$%^&", userLeadData.numberOfRooms)

            toast.warning("Please Enter Number Of Floor", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        else if (!userLeadData.RoomsPerFloor) {
            toast.warning("Please Enter Rooms per Floor", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        else if (!selectExistingInternetOutflow?.value) {
            toast.warning("Please Select Existing Internet Outflow", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        else if (!leadName) {
            toast.warning("Please Enter Lead Name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!selectedCompany || (!selectedCompany.label && !selectedCompany.value)) {
            toast.warning("Please Enter Company Name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!groupOptions) {
            toast.warning("Please Select Group Name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }

        else if (!selectRelationship) {
            toast.warning('Please Select Relationship', {
                position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
            });
        }


        else if (!selectState || (!selectState.value && !selectState.label)) {
            toast.warning("Please Select State", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!selectCity || (!selectCity.value && !selectCity.label)) {
            toast.warning("Please Select City", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!selectArea || (!selectArea.value && !selectArea.label)) {
            toast.warning("Please Select Area", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!selectBuilding || (!selectBuilding.value && !selectBuilding.label)) {
            toast.warning("Please Enter Building Name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!userLeadData.buildingNum) {
            toast.warning("Please Enter Building Number", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!userLeadData.block) {
            toast.warning("Please Enter Block", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!userLeadData.floor) {
            toast.warning("Please Enter Floor", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!userLeadData.pin) {
            toast.warning("Please Enter Pin Code", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (userLeadData.pin.length < 6) {
            toast.warning("Please Enter Pin Code", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }

        else if (!selectStateOne || (!selectStateOne.label && !selectStateOne.value)) {
            toast.warning("Please Select State", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!selectCityOne || (!selectCityOne?.label && !selectCityOne?.value)) {
            toast.warning("Please Select City", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!selectAreaOne || (!selectAreaOne.label && !selectAreaOne.value)) {
            toast.warning("Please Select Area", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!selectBuildingOne || (!selectBuildingOne.label && !selectBuildingOne.value)) {
            toast.warning("Please Enter Building Name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!userLeadData.buildingNumOne) {
            toast.warning("Please Enter Building Number", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!userLeadData.blockOne) {
            toast.warning("Please Enter Block", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!userLeadData.floorOne) {
            toast.warning("Please Enter Floor", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!userLeadData.pinOne) {
            toast.warning("Please Enter Pin Code", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (userLeadData.pinOne.length < 6) {
            toast.warning("Please Enter Pin Code", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        else {
            // update lead form data
            if (leadId) {
                setLoading(true);
                const leadUpdateUrl = process.env.REACT_APP_API_URL;
                const leadUpdationData = {
                    Action: "updateLeadHotel",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    CompanyDetail: {
                        companyName: (companyName || comName).split("(")[0].trim() || "",
                        firmType: `${selectFirmType.value}` ? `${selectFirmType.value}` : "",
                        industryType: selectIndustryType.value ? selectIndustryType.value : "",
                        jobTitle: userLeadData.jobTitle ? userLeadData.jobTitle : "",
                    },
                    ContactAddress: {
                        contactArea: selectAreaOne.label
                            ? selectAreaOne.label.split("(")[1].split(")")[0].trim()
                            : "",
                        contactBuilding: selectBuildingOne.label
                            ? selectBuildingOne.label.split("(")[1].split(")")[0].trim()
                            : "",
                        contactCity: selectCityOne.value ? selectCityOne.value : "",
                        contactCountry: '10001', // selectCountryOne.value ? selectCountryOne.value : "",
                        contactFloor: userLeadData.floorOne ? userLeadData.floorOne : "",
                        contactPincode: userLeadData.pinOne ? userLeadData.pinOne : "",
                        contactPlotNo: userLeadData.buildingNumOne
                            ? userLeadData.buildingNumOne
                            : "",
                        contactSpecifyArea: userLeadData.specifyAreaOne
                            ? userLeadData.specifyAreaOne
                            : " ",
                        contactSpecifyBuilding: userLeadData.specifyBuildingOne
                            ? userLeadData.specifyBuildingOne
                            : "",
                        contactState: selectStateOne.value ? selectStateOne.value : "",
                        contactblock: userLeadData.blockOne ? userLeadData.blockOne : "",
                    },
                    InstallationAddress: {
                        block: userLeadData.block ? userLeadData.block : "",
                        installArea: selectArea.label
                            ? selectArea.label.split("(")[1].split(")")[0].trim()
                            : "",
                        installBuilding: selectBuilding.label
                            ? selectBuilding.label.split("(")[1].split(")")[0].trim()
                            : "",
                        installCity: selectCity.value ? selectCity.value : "",
                        installCountry: selectCountry.value ? selectCountry.value : "",
                        installFloor: userLeadData.floor ? userLeadData.floor : "",
                        installPincode: userLeadData.pin ? userLeadData.pin : " ",
                        installPlotNo: userLeadData.buildingNum
                            ? userLeadData.buildingNum
                            : "",
                        installSociety: "0",
                        installSpecifyArea: userLeadData.specifyArea
                            ? userLeadData.specifyArea
                            : "",
                        installSpecifyBuilding: userLeadData.specifyBuilding
                            ? userLeadData.specifyBuilding
                            : "",
                        installState: selectState.value ? selectState.value : "",
                    },
                    HotelInfo: {
                        PGType: "",
                        TenantType: "",
                        Designation: selectDesignation?.value ? selectDesignation?.value : "",
                        DesignationOthers: userLeadData.specificDesignation || "",
                        Role: selectRole?.value || "",
                        NumberOfRooms: userLeadData.numberOfRooms || "",
                        NumberofBeds: userLeadData.numberOfBeds || "",
                        PerBedRent: userLeadData.perBedRent || "",
                        ExistingInternetProvider: selectExistingInternetProvider?.value || "",
                        OtherExistingInternetProvider: userLeadData.specificExistingInternetProvider || "",
                        ExistingInternetOutFlowPerMonth: selectExistingInternetOutflow?.value || "",
                        OtherExistingInternetOutFlowPerMonth: userLeadData.existingInternetOutflowOther || "",
                        CurrentInfra: "",
                        CurrentInfraOther: userLeadData.currentInfraOther || "",
                        GoogleRatings: userLeadData.googleRatings || "",
                        PgInternetRatings: userLeadData.hotelInternetRatings || "",

                        // Dynamically assign "1" or "0" based on the existence of each pain point in the array.
                        ClientProfile: userLeadData?.ClientProfile || "",
                        DailyRoomRentAvg: userLeadData?.DailyRoomRent || "",
                        DetailsOfTvsCctvIot: userLeadData?.DetailsofTVsCCTVIOT || "",
                        DurationOfLease: userLeadData?.LeasePeriod || "",
                        NoOfFloors: userLeadData?.NoofFloors || "",
                        RoomsPerFloor: userLeadData?.RoomsPerFloor || "",
                        TypeOfProperty: userLeadData?.PropertyType || "",
                        // "NumberOfRooms": userLeadData?.numberOfRooms || "",
                        "Latitude": leadlatitude,
                        "Longitude": leadlongitude,
                        PoorCustomerReviews: "",
                        TenantComplaints: "",
                        TenantChurn: "",
                        PoorCustomerSupportfromexistingvendor: "",
                        MultipleVendors: "",
                        NewBuilding: "",

                        FrequentDowntime: "",

                        SpeedPerformance: "",

                        HighLatency: "",

                        BillingDiscrepancies: "",

                        PoorServiceSupportSLAViolations: "",

                        LimitedScalabilityUpgradeChallenges: "",

                        SecurityConcernsComplianceIssues: "",

                        BadCoverageInfrastructureLimitations: "",

                        NoRedundancybackuplink: "",

                        NoMonitoringUsageReport: userLeadData.painPoints?.includes("NoMonitoringUsageReport") ? "1" : "0",
                        AccessIssuesAuthentication: userLeadData.painPoints?.includes("AccessIssuesAuthentication") ? "1" : "0",
                        UnableToEnhanceExperience: userLeadData.painPoints?.includes("UnableToEnhanceExperience") ? "1" : "0",
                        OutDatedSetup: userLeadData.painPoints?.includes("OutDatedSetup") ? "1" : "0",
                        LackOfItExpertise: userLeadData.painPoints?.includes("LackOfItExpertise") ? "1" : "0",
                        CustommerComplaints: userLeadData.painPoints?.includes("CustommerComplaints") ? "1" : "0",
                        ServiceSupportChallenges: userLeadData.painPoints?.includes("ServiceSupportChallenges") ? "1" : "0",
                        Other: userLeadData.painPoints?.includes("Other") ? "1" : "0",
                        PpOthers: userLeadData?.PpOthers || "",
                        UrgentTriggers: "",
                        "SpectraRelationship": selectSpectraRelationship?.value ? selectSpectraRelationship?.value : "",
                        PaymentTerms: selectPayment?.value || "",

                        ExistingConnectivity: selectExistConnectivity?.value ? selectExistConnectivity?.value : "",
                        Barriers: selectBarrier?.value ? selectBarrier?.value : "",
                        NumberofInternetUsers: officeEmpCount?.value ? officeEmpCount?.value : "",
                        OfficeArea: coverageAreaRange?.value ? coverageAreaRange?.value : "",
                        Applications: selectApplications?.value ? selectApplications?.value : "",
                        ProductName: productName?.value ? productName?.value : "",
                        CompanyTurnover: selectTurnOver.value ? selectTurnOver.value : "",
                        EmployeeCount: officeEmpCount?.value ? officeEmpCount?.value : "",
                    },

                    SDWAN: {
                        applicationsHosted: "",
                        currentOperationalCity: "",
                        customerBroadbandServices: "",
                        customerILLservices: "",
                        customerRoutingServices: "",
                        firewallSetToExpire: "",
                        indicationITSpent: "",
                        itSupport: "",
                        linksManagedLinks: "",
                        mPLSBackbone: "",
                        mPLSContract: "",
                        networkSecurityServices: "",
                        noOfLocation: "",
                        numberOfLinksBroadbandServices: "",
                        numberOfLinksIll: "",
                        redundancyMPLS: "",
                        sdwanRemarks: "",
                    },
                    businessSegment: "Business",
                    companyID: selectedCompany?.value || "",
                    contactPersonName: userLeadData.PersonalName
                        ? userLeadData.PersonalName
                        : " ",
                    customersegment: `${selectCustomerSeg.value}` ? `${selectCustomerSeg.value}` : "111260000",
                    emailId: userLeadData.email ? userLeadData.email : " ",
                    ems: "3",
                    firstName: leadName ? leadName.split("(")[0].trim() : "",
                    groupID: groupOptions ? groupOptions[0].value : "",
                    isSameAddress: useSameData ? `${1}` : `${0}`,
                    lastName: "",
                    leadChannel: selectLeadChannel.value ? selectLeadChannel.value : "FFA APP",
                    leadId: userLeadData.leadId ? userLeadData.leadId : " ",
                    // leadId: "L-03-2025-281358",
                    leadSource: selectLeadSource?.value ? selectLeadSource?.value : "",
                    leadTopic: userLeadData.topic ? userLeadData.topic : "",
                    mobileNo: userLeadData.mobileNo ? userLeadData.mobileNo : " ",
                    otherDetail: {
                        currentWorkingLocation: selectCurrentWorkLocation.value
                            ? selectCurrentWorkLocation.value
                            : "",
                        existingServiceProvider1: `${selectExServiceProviderOne.value}`
                            ? `${selectExServiceProviderOne.value}`
                            : "",
                        existingServiceProvider2: `${selectExServiceProviderTwo.value}`
                            ? `${selectExServiceProviderTwo.value}`
                            : "",
                        isDatacenter: `${selectDataCenter.value}` ? `${selectDataCenter.value}` : "false",
                        isFirewall: `${selectInterestedFirewall.value}`
                            ? `${selectInterestedFirewall.value}`
                            : "false",
                        isManagesWiFi: `${selectInterestedManageWiFi.value}`
                            ? `${selectInterestedManageWiFi.value}`
                            : "false",
                        isVOIP: `${selectInterestedVOIP.value}` ? `${selectInterestedVOIP.value}` : "false",
                        isVPN: `${selectInterestedVPN.value}` ? `${selectInterestedVPN.value}` : "false",
                        media: `${selectMedia.value}` ? `${selectMedia.value}` : "",
                        serviceFromServiceProvider1: `${selectServiceProviderOne.value}`
                            ? `${selectServiceProviderOne.value}`
                            : "",
                        serviceFromServiceProvider2: `${selectServiceProviderTwo.value}`
                            ? `${selectServiceProviderTwo.value}`
                            : "",
                        targetInstallationPeriod: formatDateString(
                            userLeadData.targetInstallationPeriod
                        )
                            ? formatDateString(userLeadData.targetInstallationPeriod)
                            : "",
                    },
                    password: sessionStorage.getItem("password"),
                    productName: selectProduct?.value ? selectProduct?.value : "",
                    relationshipId: selectRelationship.value ? selectRelationship.value : "",
                    remark: userLeadData.remark ? userLeadData.remark : "",
                    salutationId: selectSalutation.value ? selectSalutation.value : "",
                    specifyleadsource: specifyleadsource.value ? specifyleadsource.value : "",
                    subBusinessSegment: selectSubBusiness.label ? selectSubBusiness.label : "Internet Service",
                    userName: sessionStorage.getItem("userName"),
                    verticalID: selectedVertical?.value,


                };

                // console.log("leadUpdationData: ", leadUpdationData); return

                try {
                    const response = await fetch(leadUpdateUrl, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(leadUpdationData),
                    });
                    //console.log('Request Payload:', JSON.stringify(leadUpdationData))
                    const data = await response.json();
                    // console.log('API Response lead create:', data);
                    if (data.Status !== "Failure") {
                        setLoading(false);
                        toast.success("Lead Updated Successfully", {
                            position: toast.POSITION.BOTTOM_CENTER,
                            autoClose: 1500,
                        });

                        // navigate(`/BusinessLeadFormHotel?LeadId=${leadId}`);
                        navigate("/BusinessLeadHotel");

                        // setTimeout(() => {
                        //     window.location.reload();
                        // }, 1500);
                    } else {
                        setLoading(false);
                        toast.warning(data.Response.Message, {
                            position: toast.POSITION.BOTTOM_CENTER,
                            autoClose: 1500,
                        });
                    }
                } catch (error) {
                    console.error("Error creating lead:", error);
                    toast.error("An error occurred. Please try again later.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                }
            } else {
                // create lead data
                setLoading(true);
                const leadCreateUrl = process.env.REACT_APP_API_URL;
                const leadCreationData = {
                    Action: "createLead",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    CompanyDetail: {
                        companyName: companyName ? companyName.split("(")[0].trim() : "",
                        firmType: selectFirmType.value ? selectFirmType.value : "",
                        industryType: selectIndustryType.value ? selectIndustryType.value : "",
                        jobTitle: userLeadData.jobTitle ? userLeadData.jobTitle : "",
                    },
                    ContactAddress: {
                        contactArea: selectAreaOne.label
                            ? selectAreaOne.label.split("(")[1].split(")")[0].trim()
                            : "",
                        contactBuilding: selectBuildingOne.label
                            ? selectBuildingOne.label.split("(")[1].split(")")[0].trim()
                            : "",
                        contactCity: selectCityOne.value ? selectCityOne.value : "",
                        contactCountry: selectCountryOne.value ? selectCountryOne.value : "",
                        contactFloor: userLeadData.floorOne ? userLeadData.floorOne : "",
                        contactPincode: userLeadData.pinOne ? userLeadData.pinOne : "",
                        contactPlotNo: userLeadData.buildingNumOne
                            ? userLeadData.buildingNumOne
                            : "",
                        contactSpecifyArea: userLeadData.specifyAreaOne
                            ? userLeadData.specifyAreaOne
                            : " ",
                        contactSpecifyBuilding: userLeadData.specifyBuildingOne
                            ? userLeadData.specifyBuildingOne
                            : "",
                        contactState: selectStateOne.value ? selectStateOne.value : "",
                        contactblock: userLeadData.blockOne ? userLeadData.blockOne : "",
                    },
                    InstallationAddress: {
                        block: userLeadData.block ? userLeadData.block : "",
                        installArea: selectArea.label
                            ? selectArea.label.split("(")[1].split(")")[0].trim()
                            : "",
                        installBuilding: selectBuilding.label
                            ? selectBuilding.label.split("(")[1].split(")")[0].trim()
                            : "",
                        installCity: selectCity.value ? selectCity.value : "",
                        installCountry: selectCountry.value ? selectCountry.value : "",
                        installFloor: userLeadData.floor ? userLeadData.floor : "",
                        installPincode: userLeadData.pin ? userLeadData.pin : " ",
                        installPlotNo: userLeadData.buildingNum
                            ? userLeadData.buildingNum
                            : "",
                        installSociety: "0",
                        installSpecifyArea: userLeadData.specifyArea
                            ? userLeadData.specifyArea
                            : "",
                        installSpecifyBuilding: userLeadData.specifyBuilding
                            ? userLeadData.specifyBuilding
                            : "",
                        installState: selectState.value ? selectState.value : "",
                    },
                    SDWAN: {
                        indicationITSpent: "",
                        noOfLocation: "",
                        numberOfLinksBroadbandServices: "",
                        numberOfLinksIll: "",
                        sdwanRemarks: "",
                    },
                    businessSegment: "Business",
                    channelPartner: "",
                    companyID: selectedCompany?.value || "",
                    contactPersonName: userLeadData.PersonName
                        ? userLeadData.PersonName
                        : "",
                    customersegment: selectCustomerSeg.value ? selectCustomerSeg.value : "",
                    emailId: userLeadData.email ? userLeadData.email : "",
                    ems: "3",
                    firstName: leadName ? leadName.split("(")[0].trim() : "",
                    groupID: groupOptions ? groupOptions[0]?.value : "",
                    isSameAddress: useSameData ? 1 : 0,
                    lastName: "",
                    leadChannel: selectLeadChannel.value ? selectLeadChannel.value : "FFA APP",
                    leadId: userLeadData.leadId ? userLeadData.leadId : " ",
                    leadSource: selectLeadSource.value ? selectLeadSource.value : "",
                    leadTopic: userLeadData.topic ? userLeadData.topic : "",
                    mobileNo: userLeadData.mobileNo ? userLeadData.mobileNo : " ",
                    otherDetail: {
                        actualContract: "",
                        contractExpDate: formatDateString(userLeadData.contractExpDate)
                            ? formatDateString(userLeadData.contractExpDate)
                            : "",
                        currentWorkingLocation: selectCurrentWorkLocation.value
                            ? selectCurrentWorkLocation.value
                            : "",
                        detailServProvInfra: userLeadData.detailServProvInfra
                            ? userLeadData.detailServProvInfra
                            : " ",
                        existingServProvInfra: selectExistingServProvInfra.value
                            ? selectExistingServProvInfra.value
                            : "",
                        existingServiceProvider1: selectExServiceProviderOne.value
                            ? selectExServiceProviderOne.value
                            : "",
                        existingServiceProvider2: selectExServiceProviderTwo.value
                            ? selectExServiceProviderTwo.value
                            : "",
                        howManyLocations: userLeadData.howManyLocations
                            ? userLeadData.howManyLocations
                            : " ",
                        isCustUsingFirewall: selectFirewall.value ? selectFirewall.value : "",
                        isDatacenter: selectDataCenter.value ? selectDataCenter.value : "",
                        isFirewall: selectInterestedFirewall.value
                            ? selectInterestedFirewall.value
                            : "",
                        isManagesWiFi: selectInterestedManageWiFi.value
                            ? selectInterestedManageWiFi.value
                            : "",
                        isMultilocationCust: selectIsMultilocationCust.value
                            ? selectIsMultilocationCust.value
                            : "",
                        isVOIP: selectInterestedVOIP.value ? selectInterestedVOIP.value : "",
                        isVPN: selectInterestedVPN.value ? selectInterestedVPN.value : "",
                        media: selectMedia.value ? selectMedia.value : "",
                        paymentMode: selectPaymentMode.value ? selectPaymentMode.value : "",
                        serviceFromServiceProvider1: selectServiceProviderOne.value
                            ? selectServiceProviderOne.value
                            : "",
                        serviceFromServiceProvider2: selectServiceProviderTwo.value
                            ? selectServiceProviderTwo.value
                            : "",
                        spendOnFirewall: userLeadData.onFirewall
                            ? userLeadData.onFirewall
                            : "",
                        targetInstallationPeriod: formatDateString(
                            userLeadData.targetInstallationPeriod
                        )
                            ? formatDateString(userLeadData.targetInstallationPeriod)
                            : "",
                    },
                    password: sessionStorage.getItem("password"),
                    productName: selectProduct?.value ? selectProduct?.value : "",
                    relationshipId: selectRelationship.value ? selectRelationship.value : "",
                    remark: userLeadData.remark ? userLeadData.remark : "",
                    salutationId: selectSalutation.value ? selectSalutation.value : "",
                    specifyleadsource: specifyleadsource.value ? specifyleadsource.value : "",
                    subBusinessSegment: "",
                    userName: sessionStorage.getItem("userName"),


                };
                try {
                    const response = await fetch(leadCreateUrl, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(leadCreationData),
                    });
                    //console.log('Request Payload:', JSON.stringify(leadCreationData))
                    const data = await response.json();
                    //console.log('API Response lead create:', data);
                    if (data.Response.Message === "Lead Created Successfully") {
                        setLoading(false);
                        toast.success("Lead Created Successfully", {
                            position: toast.POSITION.BOTTOM_CENTER,
                            autoClose: 1500,
                        });
                        navigate("/BusinessLeadHotel");
                    } else {
                        toast.warning(data.Response.Message, {
                            position: toast.POSITION.BOTTOM_CENTER,
                            autoClose: 1500,
                        });
                        setLoading(false);
                    }
                } catch (error) {
                    console.error("Error creating lead:", error);
                    toast.error("An error occurred. Please try again later.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                }
            }
        }
    };



    const handleQualifyLead = async () => {

        const parseDateFromDDMMYYYY = (dateStr) => {
            // Expects dateStr in "DD-MM-YYYY" format.
            const [day, month, year] = dateStr.split('-').map(Number);
            return new Date(year, month - 1, day);
        };

        const selectedDate = parseDateFromDDMMYYYY(userLeadData.targetInstallationPeriod);
        // const selectedDate = userLeadData.targetInstallationPeriod;

        const currentDate = new Date();
        const diffTime = selectedDate.getTime() - currentDate.getTime();
        const diffDays = diffTime / (1000 * 3600 * 24);
        // console.log("        userLeadData.targetInstallationPeriod; Date:", userLeadData.targetInstallationPeriod);
        // console.log("Selected Date:", selectedDate);

        // console.log("Current Date:", currentDate);
        // console.log("Difference in Days:", diffDays);

        if (!companyName) {
            toast.warning("Please Enter Company Name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        else if (!selectIndustryType.value) {
            toast.warning("Please Select Industry Segment", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        // else if (selectFirmType.value == "0") {
        //     toast.warning("Please Select Firm Type", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // }
        //  else if (selectTurnOver.value == "0") {
        //     toast.warning("Please Select Company Turnover", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // }
        else if (!selectExistingInternetProvider?.value) {
            toast.warning('Existing Internet Provider must be selected', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
        }
        else if (selectExistingInternetProvider?.value == "111260005" && !userLeadData.specificExistingInternetProvider) {
            toast.warning('Specific Internet Provider must be entered', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
        }
        else if (!selectExistingInternetOutflow?.value) {
            toast.warning('Existing Internet Outflow must be selected', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
        }
        else if (selectExistingInternetOutflow?.value == "111260007" && !userLeadData.existingInternetOutflowOther) {
            toast.warning('Specific Existing Internet Outflow must be entered', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
        }

        // else if (!userLeadData.targetInstallationPeriod) {
        //     toast.warning("Please Select Expected Installation Date", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // } else if (!selectPayment) {
        //     toast.warning("Please Select Payment Terms", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // }
        else if (!leadlatitude) {
            toast.warning("Please Select latitude", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (!leadlongitude) {
            toast.warning("Please Select longitude", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        // else if (selectBarrier.value === "0") {
        //     toast.warning("Please Select Barrier", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // }
        // else if (!officeEmpCount.value) {
        //     toast.warning("Please Enter Office Employee Count", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // }
        // else if (!coverageAreaRange.value) {
        //     toast.warning("Please Select Coverage Office Area", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // }
        // else if (selectApplications.value == "0") {
        //     toast.warning("Please Select Applications", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // }
        else if (selectDesignation.value == "0") {
            toast.warning("Please Select Designation", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else if (selectDesignation.value == "111260003" && !userLeadData.specificDesignation) {
            toast.warning("Please Enter Specific Designation", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        // else if (diffDays > 60) {
        //     toast.error("Expected Installation Date must not be more than 60 days ahead", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // }

        else {
            // alert("done")
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    Action: "getCompanyGroupDigi",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    customerName: comName,
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName')
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });
                const data = await response.json();
                // console.log("companyId", companyId);
                setGetDigiCompanyId(data.Response.CompanyID);
                if (data.Response.StatusCode == 200 && companyId !== "CNew") {
                    // alert("data.Response.StatusCode == 200 && companyId !== 'CNew'")
                    try {
                        const apiUrl = process.env.REACT_APP_API_URL;
                        const requestData = {
                            "Action": "getCompanyRelationship",
                            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            "CompanyID": companyId ? companyId : "",
                            "GroupID": getGroup ? getGroup : "",
                            "City": getCity ? getCity : "",
                            "password": sessionStorage.getItem('password'),
                            "userName": sessionStorage.getItem('userName')
                        };
                        const response = await fetch(apiUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(requestData),
                        });
                        const data = await response.json();
                        if (data.Response.StatusCode == 200 && relationShipId !== "10New") {
                            // console.log(getCity, relationShipId, selectCity,);
                            // console.log(getCity.label, selectRelationship.label);

                            if (getCity == selectRelationship.label) {
                                try {
                                    const apiUrl = process.env.REACT_APP_API_URL;
                                    const requestData = {
                                        Action: "qualifyLead",
                                        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                        leadId: leadId,
                                        password: sessionStorage.getItem('password'),
                                        userName: sessionStorage.getItem('userName'),
                                    };
                                    const response = await fetch(apiUrl, {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify(requestData),
                                    });
                                    const data = await response.json();
                                    // console.log("API Response:", data);
                                    if (data.Response.StatusCode === 200) {
                                        toast.success("Lead Qualify Successfully", {
                                            position: toast.POSITION.BOTTOM_CENTER,
                                            autoClose: 1500,
                                        });
                                        navigate("/BusinessOpportunityHotel");
                                    } else {
                                        toast.warning(data.Response.Message, {
                                            position: toast.POSITION.BOTTOM_CENTER,
                                            autoClose: 1500,
                                        });
                                    }
                                } catch (error) {
                                    console.error("Error during API call:", error);
                                }
                            } else {
                                Swal.fire({
                                    // title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
                                    text: "Selected City on Installation Address and Relationship ID must be same.",
                                    confirmButtonText:
                                        '<span style="font-size: 15px;">Ok</span>',
                                    confirmButtonColor: "rgb(148,101,170)",
                                }).then(async (result) => {
                                    if (result.isConfirmed) {
                                        navigate(`/BusinessLeadFormHotel?LeadId=${leadId}`);
                                    }
                                    else {
                                        navigate(`/BusinessLeadFormHotel?LeadId=${leadId}`);
                                    }
                                })
                            }
                        } else if (data.Response.StatusCode == 200 && relationShipId == "10New") {
                            Swal.fire({
                                // title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
                                text: "Company & Relationship ID exist in CRM. Select and proceed with lead qualification.",
                                confirmButtonText:
                                    '<span style="font-size: 15px;">Ok</span>',
                                confirmButtonColor: "rgb(148,101,170)",
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    navigate(`/BusinessLeadFormHotel?LeadId=${leadId}`);
                                }
                                else {
                                    navigate(`/BusinessLeadFormHotel?LeadId=${leadId}`);
                                }
                            })
                        } else if (data.Response.StatusCode == 400 && data.Response.RelationShipID == "") {

                            try {
                                const apiUrl = process.env.REACT_APP_API_URL;
                                const requestData = {
                                    Action: "qualifyLead",
                                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                    leadId: leadId,
                                    password: sessionStorage.getItem('password'),
                                    userName: sessionStorage.getItem('userName'),
                                };
                                const response = await fetch(apiUrl, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify(requestData),
                                });
                                const data = await response.json();
                                // console.log("API Response:", data);
                                if (data.Response.StatusCode === 200) {
                                    toast.success("Lead Qualify Successfully", {
                                        position: toast.POSITION.BOTTOM_CENTER,
                                        autoClose: 1500,
                                    });
                                    navigate("/BusinessOpportunityHotel");
                                } else {
                                    toast.warning(data.Response.Message, {
                                        position: toast.POSITION.BOTTOM_CENTER,
                                        autoClose: 1500,
                                    });
                                }
                            } catch (error) {
                                console.error("Error during API call:", error);
                            }

                        }
                    } catch (error) {
                        console.error("Error during API call:", error);
                    }

                } else if (data.Response.StatusCode == 400 && getDigiCompanyId == "" && data.Response.Message !== "Please pass valid customer name.") {

                    try {
                        const apiUrl = process.env.REACT_APP_API_URL;
                        const requestData = {
                            Action: "qualifyLead",
                            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            leadId: leadId,
                            password: sessionStorage.getItem('password'),
                            userName: sessionStorage.getItem('userName'),
                        };
                        const response = await fetch(apiUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(requestData),
                        });
                        const data = await response.json();
                        // console.log("API Response:", data);
                        if (data.Response.StatusCode === 200) {
                            toast.success("Lead Qualify Successfully", {
                                position: toast.POSITION.BOTTOM_CENTER,
                                autoClose: 1500,
                            });
                            navigate("/BusinessOpportunityHotel");
                        } else {
                            toast.warning(data.Response.Message, {
                                position: toast.POSITION.BOTTOM_CENTER,
                                autoClose: 1500,
                            });
                        }
                    } catch (error) {
                        console.error("Error during API call:", error);
                    }

                } else if (data.Response.StatusCode == 200 && companyId == "CNew") {
                    // alert("data.Response.StatusCode == 200 && companyId == 'CNew'")
                    Swal.fire({
                        // title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
                        text: "Company and Group hierarchy already exists in CRM, Please select the same and proceed for lead qualification",
                        confirmButtonText:
                            '<span style="font-size: 15px;">Ok</span>',
                        confirmButtonColor: "rgb(148,101,170)",
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            navigate(`/BusinessLeadFormHotel?LeadId=${leadId}`);
                        }
                        else {
                            navigate(`/BusinessLeadFormHotel?LeadId=${leadId}`);
                        }
                    })
                }
            } catch (error) {
                console.error("Error during API call:", error);
            } finally {
                setLoading(false);
            }
        }
    };



    let specifyleadsource = "";
    if (selectLeadSource.value === "Other") {
        specifyleadsource = "other";
    } else {
        specifyleadsource = "";
    }


    const handleIconClick = (formId) => {
        setActiveForm((prevActiveBox) =>
            prevActiveBox === formId ? null : formId
        );
    };

    // const groupValue = groupOptions.length > 0 ? groupOptions[0].value : null;
    const navigate = useNavigate();
    const redirectLeadPage = () => {
        Swal.fire({
            html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                navigate("/BusinessLeadHotel");
            } else {
                if (leadId) {
                    navigate(`/BusinessLeadFormHotel?LeadId=${leadId}`);
                } else {
                    navigate("/BusinessLeadFormHotel");
                }
            }
        });
    };

    const mobileNo = userLeadData.mobileNo;
    const redirectFLR = () => {
        if (mobileNo) {
            // console.log(leadId)
            navigate(`/flrcreate?LeadId=${leadId}&mobileNo=${mobileNo}`);
        }
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            // backgroundColor: "black",
            color: "white",
            // border: "none",
            boxShadow: state.isFocused ? "none" : provided.boxShadow,
            textAlign: "center",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "white",
        }),
        option: (provided, state) => ({
            ...provided,
            // backgroundColor: state.isFocused ? 'blue' : 'black',
            color: "black",
            textAlign: "center",
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#f0f0f0',
            borderRadius: '4px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#333',
        }),
    };

    // ==================== SDWAN ===================

    useEffect(() => {
        // Replace with your actual API endpoint
        fetch(process.env.REACT_APP_API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                Action: "getVertical",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                // password: "S@lesperson@20#!24$",
                stateCode: "",
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
                // userName: "salesperson1"
            })
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.Status === "Success") {
                    const options = data.Response.Data.map((vertical) => ({
                        value: vertical.VerticalId,
                        label: vertical.VerticalName
                    }));
                    setVerticalOptions(options);
                }
            })
            .catch((error) => console.error("Error fetching verticals:", error));
    }, []);

    // ==================== SDWAN END ===================

    return (
        <>
            {/* ***********Header********* */}
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectLeadPage}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>

                    {leadId ? (
                        <span className="p-1 m-2">Update Lead Hotel</span>
                    ) : (
                        <span className="p-1 m-2">Lead Details Hotel</span>
                    )}

                </div>
            </div>
            {/* ************Header end************ */}

            {loading ? (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={loader} alt="loading...."></img>
                    </div>
                </div>
            ) : (
                <div className="container-fluid form-container">
                    {meetingcounter >= 1 && (
                        <>
                            {/* {(status !== "1" && status !== "2" && leadId) && (
                                <div

                                >
                                    {!showForm ? (
                                        <button
                                            type="button"
                                            className="btn btn-dark w-100 mt-2 btn text-light"
                                            onClick={() => setShowForm(true)}
                                        >
                                            Disqualify
                                        </button>

                                    ) : (
                                        <>
                                            <Select
                                                isMulti
                                                options={optionQualify}
                                                value={selectedReasons}
                                                onChange={handleChanged}
                                                styles={customStyles}
                                                components={{ MultiValueRemove }}
                                                className="basic-multi-select disqualify-select"
                                                classNamePrefix="select"
                                                placeholder="Select Disqualify Reason(s)..."
                                                isSearchable={false}
                                            />
                                            <div className="d-flex justify-content-center gap-2 mt-3 mb-2">
                                                <button
                                                    type="button"
                                                    className="btn text-light bg-dark rounded-pill submit-btn"
                                                    onClick={handleDisqualify}
                                                    disabled={!selectedReasons.length}
                                                >
                                                    Disqualify
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn text-light bg-dark rounded-pill submit-btn"
                                                    onClick={() => setShowForm(false)}
                                                >
                                                    Cancel
                                                </button>
                                            </div>

                                        </>
                                    )}
                                </div>
                            )} */}
                            {(status !== "1" && status !== "2" && leadId) && (
                                <div>
                                    {!showForm ? (
                                        <button
                                            type="button"
                                            className="btn btn-dark w-100 mt-2 text-light"
                                            onClick={() => setShowForm(true)}
                                        >
                                            Disqualify
                                        </button>
                                    ) : (
                                        <>
                                            <Select
                                                isMulti
                                                options={optionQualify}
                                                value={selectedReasons}
                                                onChange={setSelectedReasons}
                                                styles={customStyles}
                                                components={{ MultiValueRemove }}
                                                className="basic-multi-select disqualify-select"
                                                classNamePrefix="select"
                                                placeholder="Select Disqualify Reason(s)..."
                                                isSearchable={false}
                                            />

                                            {/* show the input only if “Other” was chosen */}
                                            {selectedReasons.some(r => r.value === "other") && (
                                                <input
                                                    type="text"
                                                    className="form-control mt-2"
                                                    placeholder="Please specify..."
                                                    value={otherText}
                                                    onChange={e => setOtherText(e.target.value)}
                                                />
                                            )}

                                            <div className="d-flex justify-content-center gap-2 mt-3 mb-2">
                                                <button
                                                    type="button"
                                                    className="btn text-light bg-dark rounded-pill submit-btn"
                                                    onClick={handleDisqualify}
                                                    disabled={
                                                        !selectedReasons.length ||
                                                        (selectedReasons.some(r => r.value === "other") && !otherText.trim())
                                                    }
                                                >
                                                    Disqualify
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn text-light bg-dark rounded-pill submit-btn"
                                                    onClick={() => {
                                                        setShowForm(false);
                                                        setSelectedReasons([]);
                                                        setOtherText("");
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            )}


                            {status === "0" ? (
                                <button
                                    className="btn w-100 mt-2 qualify-btn text-light"
                                    onClick={handleQualifyLead}
                                >
                                    Qualify
                                </button>
                            ) : (
                                ""
                            )}
                        </>
                    )}
                    {/* **************Contact Information toggle******************* */}
                    <div
                        className="contact-toggle mt-3"
                        onClick={() => handleIconClick("form1")}
                    >
                        <span className="toggle-text">Contact Information</span>
                        <span className=" float-end">
                            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                        </span>
                    </div>

                    {activeForm === "form1" && (
                        <div
                            className=" container shadow  mb-3 bg-body rounded mt-4"
                            id="form1"
                        >
                            <form className="lead-form p-2">
                                {leadId && (
                                    <div
                                        className="input-box form-floating"
                                        style={{ position: "relative", paddingTop: "4px" }}
                                    >
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="leadId"
                                            name="leadId"
                                            value={leadId}
                                            onChange={handleChange}
                                            readOnly={true}
                                            style={{ background: "transparent" }}
                                        />
                                        <i
                                            className="fa-solid fa-lock text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "20px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                        <label htmlFor="floatingInput " className="leadId  mt-2">
                                            Lead Id
                                        </label>
                                    </div>
                                )}


                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-2"
                                        id="company"
                                        name="CompanyName"
                                        value={companyName}
                                        onChange={(e) => setCompanyName(e.target.value)}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">Name of Hotel* </label>
                                </div>

                                <div className="">
                                    <label className="select-search-label mt-1">
                                        Industry Segment*
                                    </label>
                                    <Select
                                        className=" basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="industryType"
                                        placeholder="Select IndustryType"
                                        styles={style}
                                        value={selectIndustryType}
                                        isSearchable={true}
                                        onChange={handleSelectIndustryType}
                                        options={industryTypes.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />
                                </div>







                                <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="leadlatitude"
                                        name="leadlatitude"
                                        value={leadlatitude}
                                        onChange={handleChange}
                                        style={{ background: "transparent" }}
                                        disabled
                                    />
                                    <i
                                        className="fa-solid fa-lock text-secondary"
                                        style={{
                                            position: "absolute",
                                            right: "20px",
                                            top: "60%",
                                            transform: "translateY(-50%)",
                                        }}
                                    ></i>
                                    <label htmlFor="floatingInput" className="m-0">Latitude*</label>
                                </div>



                                <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="leadlongitude"
                                        name="leadlongitude"
                                        value={leadlongitude}
                                        onChange={handleChange}
                                        style={{ background: "transparent" }}
                                        disabled
                                    />
                                    <i
                                        className="fa-solid fa-lock text-secondary"
                                        style={{
                                            position: "absolute",
                                            right: "20px",
                                            top: "60%",
                                            transform: "translateY(-50%)",
                                        }}
                                    ></i>
                                    <label htmlFor="floatingInput" className="m-0">Longitude*</label>
                                </div>


                                <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="SpectraRFS"
                                        name="SpectraRFS"
                                        value={userLeadData.SpectraRFS}
                                        onChange={handleChange}
                                        style={{ background: "transparent" }}
                                        disabled
                                    />
                                    <i
                                        className="fa-solid fa-lock text-secondary"
                                        style={{
                                            position: "absolute",
                                            right: "20px",
                                            top: "60%",
                                            transform: "translateY(-50%)",
                                        }}
                                    ></i>
                                    <label htmlFor="floatingInput" className="m-0">Spectra RFS</label>
                                </div>



                                <div className="">
                                    <label className="select-search-label mt-1">
                                        Designation*
                                    </label>
                                    <Select
                                        className=" basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="designation"
                                        placeholder="Select Option"
                                        styles={style}
                                        value={selectDesignation}
                                        isSearchable={false}
                                        onChange={handleSelectDesignation}
                                        options={optionDesignation.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />
                                </div>

                                {selectDesignation.value == "111260003" &&
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="specificDesignation"
                                            name="specificDesignation"
                                            value={userLeadData.specificDesignation}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="leadName" className="mt-2">
                                            Specific  Designation
                                        </label>
                                    </div>}


                                <div className="select-container mt-2">
                                    <label className="select-search-label">Role*</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="role"
                                        placeholder="Select"
                                        styles={style}
                                        value={selectRole}
                                        isSearchable={false}
                                        onChange={handleSelectRole}
                                        options={[
                                            { value: "111260000", label: "KDM" },
                                            { value: "111260001", label: "Influencer" },
                                        ]}
                                    />
                                </div>






                                {/* {console.log("selectSalutation :",selectSalutation.value)} */}
                                <div className="">
                                    <label className="select-search-label mt-1">Salutation*</label>
                                    <Select
                                        className=" basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="subBusiness"
                                        placeholder="Select"
                                        styles={style}
                                        value={selectSalutation}
                                        isSearchable={false}
                                        onChange={handleSelectSalutation}
                                        options={optionSalutation.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />
                                </div>

                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="PersonName"
                                        name="PersonName"
                                        value={userLeadData.PersonName ? userLeadData.PersonName : ""}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">
                                        Contact Person Name*
                                    </label>
                                </div>

                                <div className="input-box form-floating">
                                    <input
                                        type="email"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="email"
                                        name="email"
                                        value={userLeadData.email}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">
                                        Email ID*
                                    </label>
                                </div>

                                <div className="input-box form-floating">
                                    <input
                                        type="tel"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="mobileNo"
                                        name="mobileNo"
                                        maxLength="10"
                                        pattern="[0-9]{10}"
                                        value={userLeadData.mobileNo}
                                        onChange={handleChange}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (
                                                (isDigit || allowedKeys.includes(e.key)) &&
                                                (userLeadData.mobileNo.length < 10 ||
                                                    e.key === "Backspace")
                                            ) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">
                                        Mobile No*
                                    </label>
                                </div>




                                <div className="select-container mt-2">
                                    <label className="select-search-label">Client Profile</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="ClientProfile"
                                        placeholder="Select"
                                        styles={style}
                                        value={ClientProfileOptions.find((data) => data.value == userLeadData.ClientProfile)}
                                        isSearchable={false}
                                        onChange={handleSelectClientProfile}
                                        options={ClientProfileOptions}
                                    />
                                </div>

                                <div className="select-container mt-2">
                                    <label className="select-search-label">Property Type*</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="PropertyType"
                                        placeholder="Select"
                                        styles={style}
                                        value={PropertyTypeOptions.find((data) => data.value == userLeadData?.PropertyType)}
                                        isSearchable={false}
                                        onChange={handleSelectPropertyType}
                                        options={PropertyTypeOptions}
                                    />
                                </div>
                                {/* Role */}

                                {userLeadData?.PropertyType === "111260000" && (
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="LeasePeriod"
                                            name="LeasePeriod"
                                            value={userLeadData.LeasePeriod}
                                            onChange={handleChange1}
                                            // onBlur={handleBlur}


                                            style={{ background: "transparent" }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        // max="50"
                                        />
                                        <label htmlFor="numberOfRooms" className="mt-2">Lease Period (Years)</label>
                                    </div>
                                )}

                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="DailyRoomRent"
                                        name="DailyRoomRent"
                                        value={userLeadData.DailyRoomRent}
                                        onChange={handleChange1}
                                        // onBlur={handleBlur}


                                        style={{ background: "transparent" }}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (
                                                (isDigit || allowedKeys.includes(e.key))
                                                //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                            ) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                    // max="50"
                                    />
                                    <label htmlFor="DailyRoomRent" className="mt-2">Daily Room Rent (Avg.)</label>
                                </div>

                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="NoofFloors"
                                        name="NoofFloors"
                                        value={userLeadData.NoofFloors}
                                        onChange={handleChange1}
                                        // onBlur={handleBlur}


                                        style={{ background: "transparent" }}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (
                                                (isDigit || allowedKeys.includes(e.key))
                                                //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                            ) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                    // max="50"
                                    />
                                    <label htmlFor="DailyRoomRent" className="mt-2">No. of Floors*</label>
                                </div>

                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="RoomsPerFloor"
                                        name="RoomsPerFloor"
                                        value={userLeadData.RoomsPerFloor}
                                        onChange={handleChange1}
                                        // onBlur={handleBlur}


                                        style={{ background: "transparent" }}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (
                                                (isDigit || allowedKeys.includes(e.key))
                                                //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                            ) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                    // max="50"
                                    />
                                    <label htmlFor="DailyRoomRent" className="mt-2">Rooms Per Floor*</label>
                                </div>
                                <div className="input-box form-floating" >
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="numberOfRooms"
                                        name="numberOfRooms"
                                        value={userLeadData.numberOfRooms}
                                        onChange={handleChange}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (
                                                (isDigit || allowedKeys.includes(e.key))
                                                //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                            ) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                        style={{ background: "transparent" }}
                                    />

                                    <label htmlFor="numberOfRooms" className="LeadId mt-1">Number of Rooms*</label>
                                </div>
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="DetailsofTVsCCTVIOT"
                                        name="DetailsofTVsCCTVIOT"
                                        value={userLeadData.DetailsofTVsCCTVIOT}
                                        onChange={handleChange}
                                        // disabled={
                                        //     ContactId && checkStatusReason == "Lead Created/Closed"
                                        // }
                                        style={{ background: "transparent" }}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">
                                        Details of TVs / CCTV / IOT*
                                    </label>
                                </div>
                                <div className="select-container mt-2">
                                    <label className="select-search-label">Spectra Relationship*</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="spectraRelationship"
                                        placeholder="Select"
                                        styles={style}
                                        value={selectSpectraRelationship}
                                        isSearchable={false}
                                        onChange={handleSelectSpectraRelationship}
                                        options={[
                                            { value: "111260000", label: "Existing User" },
                                            { value: "111260001", label: "Past User" },
                                            { value: "111260002", label: "New" },
                                        ]}
                                    />
                                </div>
                                <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-2"
                                        id="googleRatings"
                                        disabled
                                        name="googleRatings"
                                        value={userLeadData.googleRatings}
                                        onChange={handleChange}
                                        style={{ background: "transparent" }}
                                    />
                                    <i
                                        className="fa-solid fa-lock text-secondary"
                                        style={{
                                            position: "absolute",
                                            right: "20px",
                                            top: "60%",
                                            transform: "translateY(-50%)",
                                        }}
                                    ></i>
                                    <label htmlFor="googleRatings" className="mt-1 LeadId">Hotel Google Ratings</label>
                                </div>

                                <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-2"
                                        id="hotelInternetRatings"
                                        name="hotelInternetRatings"
                                        disabled
                                        value={userLeadData.hotelInternetRatings}
                                        onChange={handleChange}
                                        style={{ background: "transparent" }}
                                    />
                                    <i
                                        className="fa-solid fa-lock text-secondary"
                                        style={{
                                            position: "absolute",
                                            right: "20px",
                                            top: "60%",
                                            transform: "translateY(-50%)",
                                        }}
                                    ></i>
                                    <label htmlFor="hotelInternetRatings" className="mt-1 LeadId">Hotel Internet Rating</label>
                                </div>









                                <div className="select-container mt-2">
                                    <label className="select-search-label">Pain Points*</label>
                                    <Select
                                        className="basic-multi-select form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="painPoints"
                                        placeholder="Select"
                                        styles={style}
                                        value={selectPainPoints}
                                        isMulti
                                        onChange={handleSelectPainPoints}
                                        options={painPointsOptions}

                                    />
                                </div>

                                {(userLeadData?.PpOthers == "1" || selectPainPoints?.find((data) => data.value == "Other")) &&
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="PpOthers"
                                            name="PpOthers"

                                            value={userLeadData.PpOthers}
                                            onChange={handleChange}
                                            style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="PpOthers" className="mt-2">Specific Pain Point*</label>
                                    </div>}

                                {/* Existing Internet Provider */}
                                <div className="select-container mt-2">
                                    <label className="select-search-label">Existing Internet Provider*</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="existingInternetProvider"
                                        placeholder="Select"
                                        styles={style}
                                        value={selectExistingInternetProvider}
                                        isSearchable={false}
                                        onChange={handleSelectExistingInternetProvider}
                                        options={[
                                            { value: "111260000", label: "Airtel" },
                                            { value: "111260001", label: "Jio" },
                                            { value: "111260002", label: "Tata" },
                                            { value: "111260003", label: "ACT" },
                                            { value: "111260006", label: "Excitel" },
                                            { value: "111260007", label: "Triple Play" },
                                            { value: "111260004", label: "New Building" },
                                            { value: "111260005", label: "Others" },
                                        ]}
                                    />
                                </div>



                                {selectExistingInternetProvider?.value == "111260005" &&
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="specificExistingInternetProvider"
                                            name="specificExistingInternetProvider"

                                            value={userLeadData.specificExistingInternetProvider}
                                            onChange={handleChange}
                                            style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="pgInternetRatings" className="mt-2">Specific Existing Internet Provider</label>
                                    </div>}




                                {/* Existing Internet Outflow Per Month */}
                                <div className="select-container mt-2">
                                    <label className="select-search-label">Existing Internet Outflow Per Month*</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="existingInternetOutflow"
                                        placeholder="Select"
                                        styles={style}
                                        value={selectExistingInternetOutflow}
                                        isSearchable={false}
                                        onChange={handleSelectExistingInternetOutflow}
                                        options={[
                                            { value: "111260000", label: "<5000" },
                                            { value: "111260001", label: "5001 - 10000" },
                                            { value: "111260008", label: "10001 - 20000" },
                                            { value: "111260009", label: ">20,000" },
                                            // { value: "111260002", label: "10001- 15000" },
                                            // { value: "111260003", label: "15001 - 20000" },
                                            // { value: "111260004", label: "20001 - 25000" },

                                            // { value: "111260005", label: ">25000" },
                                            { value: "111260006", label: "New Building" },
                                            { value: "111260007", label: "Others" },
                                        ]}
                                    />
                                </div>


                                {selectExistingInternetOutflow?.value == "111260007" &&
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="existingInternetOutflowOther"
                                            name="existingInternetOutflowOther"

                                            value={userLeadData.existingInternetOutflowOther}
                                            onChange={handleChange}
                                            style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="pgInternetRatings" className="mt-2">Specific Existing Internet Outflow Per Month</label>
                                    </div>}



                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="leadName"
                                        name="leadName"
                                        value={leadName}
                                        onChange={(e) => setLeadName(e.target.value)}
                                    />
                                    <label htmlFor="leadName" className="mt-2">
                                        Lead Name*
                                    </label>
                                </div>


                                {/* {console.log("company length :",selectedCompany)} */}
                                {/* {console.log("company :",selectedCompany)} */}
                                <div className="">
                                    <label className="select-search-label mt-1">Company*</label>
                                    <Select
                                        className=" form-control form-control-sm p-1"
                                        id="companySelect"
                                        name="company"
                                        placeholder="Search Company"
                                        value={selectedCompany}
                                        styles={style}
                                        isLoading={loaders}
                                        onChange={(selectedOption) => {
                                            handleCompanyChange(selectedOption);
                                            (selectedOption.label !== "New Company" && !leadName) && setLeadName(selectedOption.label)
                                            // setCompanyName(
                                            //     selectedOption &&
                                            //         selectedOption.label !== "New Company"
                                            //         ? selectedOption.label
                                            //         : ""
                                            // );
                                        }}
                                        options={companyOptions}
                                        isSearchable={true}
                                    />
                                </div>

                                {/* {console.log("groupOptions ",groupOptions)} */}
                                <div className="">
                                    <label className="select-search-label mt-1">Group*</label>
                                    <Select
                                        className=" basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="relationship"
                                        placeholder="Select Group"
                                        styles={style}
                                        // value={groupOptions.length > 0 ? groupOptions[0].value : null}
                                        value={selectedGroup}
                                        isSearchable={false}
                                        onChange={handleSelectGroup}
                                        options={groupOptions}
                                    />
                                </div>

                                {/* {console.log("relationship",selectRelationship)} */}
                                <div className="">
                                    <label className="select-search-label mt-1">
                                        Relationship*
                                    </label>
                                    <Select
                                        className=" basic-single form-control form-control-sm  p-1"
                                        classNamePrefix="select"
                                        name="relationship"
                                        placeholder="Select Relationship"
                                        styles={style}
                                        value={selectRelationship}
                                        isSearchable={false}
                                        onChange={handleSelectRelationship}
                                        options={relationshipOptions.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />
                                </div>

                            </form>
                        </div>
                    )}



                    {/* **************Installation Address toggle******************* */}
                    <div
                        className="Installation-toggle mt-3"
                        onClick={() => handleIconClick("form3")}
                    >
                        <span className="toggle-text">Installation Address</span>
                        <span className=" float-end">
                            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                        </span>
                    </div>

                    {activeForm === "form3" && (
                        <div
                            className="container shadow mb-3 bg-body rounded mt-4"
                            id="form3"
                        >
                            <form className="Installation-form p-2">
                                <div className="">
                                    <label className="select-search-label mt-1">Country*</label>
                                    <Select
                                        className=" basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="IndustrySeg"
                                        placeholder="Select Country"
                                        styles={style}
                                        isSearchable={false}
                                        value={{ value: '10001', label: 'India' }}
                                        onChange={handleSelectCountry}
                                        options={optionCountry.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />
                                </div>

                                <div className="">
                                    <label className="select-search-label mt-1">State*</label>
                                    <Select
                                        className=" basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="IndustrySeg"
                                        placeholder="Select State"
                                        isSearchable={false}
                                        styles={style}
                                        value={selectState}
                                        onChange={handleSelectState}
                                        options={optionState.map((data) => ({
                                            value: data.code,
                                            label: data.name,
                                        }))}
                                    />
                                </div>

                                <div className="">
                                    <label className="select-search-label mt-1">City*</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="City"
                                        placeholder="Select City"
                                        isSearchable
                                        styles={style}
                                        // value={cityType.find(
                                        //   (city) => city.CityCode === selectCity.value
                                        // )}
                                        value={selectCity}
                                        onChange={handleSelectCity}
                                        options={cityType.map((data) => ({
                                            value: data.CityCode,
                                            label: data.CityName,
                                        }))}
                                    />
                                </div>

                                <div className="search-area" style={{ position: "relative" }}>
                                    <label className="select-search-label mt-1">Area*</label>
                                    <Select
                                        options={areaList.map((area) => ({
                                            value: area.AreaCode,
                                            label: `${area.AreaName} (${area.AreaCode})`,
                                        }))}
                                        className=" form-control form-control-sm p-1 custom-select"
                                        placeholder="Search Area"
                                        isSearchable
                                        styles={style}
                                        value={selectArea}
                                        onChange={handleSelectArea}
                                    />
                                    <i
                                        className="fas fa-search text-secondary"
                                        style={{
                                            position: "absolute",
                                            right: "15px",
                                            top: "63%",
                                            transform: "translateY(-50%)",
                                        }}
                                    ></i>
                                </div>

                                <div className="search-building" style={{ position: "relative" }}>
                                    <label className="select-search-label mt-1">Building Name*</label>
                                    <Select
                                        options={buildingList.map((building) => ({
                                            value: building.BuildingCode,
                                            label: `${building.BuildingName} (${building.BuildingCode})`,
                                        }))}
                                        className="form-control form-control-sm p-1 custom-select"
                                        placeholder="Search Building"
                                        styles={style}
                                        isSearchable
                                        value={selectBuilding}
                                        onChange={(selectedOption) =>
                                            setSelectBuilding(selectedOption)
                                        }
                                    />
                                    <i
                                        className="fas fa-search text-secondary"
                                        style={{
                                            position: "absolute",
                                            right: "15px",
                                            top: "63%",
                                            transform: "translateY(-50%)",
                                        }}
                                    ></i>
                                </div>

                                <div className="input-box form-floating mt-1">
                                    {selectArea && selectArea.label.includes("Other") ? (
                                        <>
                                            <input
                                                type="text"
                                                placeholder=""
                                                className="form-control input-text form-control-sm"
                                                name="specifyArea"
                                                value={userLeadData.specifyArea}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">Specific Area Name</label>
                                        </>
                                    ) : null}
                                </div>

                                <div className="input-box form-floating">
                                    {selectBuilding && selectBuilding.label.includes("Other") ? (
                                        <>
                                            <input
                                                type="text"
                                                placeholder=""
                                                className="form-control input-text form-control-sm mt-1"
                                                id="buildingName"
                                                name="specifyBuilding"
                                                value={userLeadData.specifyBuilding}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Specific Building Name
                                            </label>
                                        </>
                                    ) : null}
                                </div>

                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="buildingNum"
                                        name="buildingNum"
                                        value={userLeadData.buildingNum}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">Building No./Plot No.*</label>
                                </div>

                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="block"
                                        name="block"
                                        value={userLeadData.block}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">Block*</label>
                                </div>

                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="floor"
                                        name="floor"
                                        value={userLeadData.floor}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">Floor*</label>
                                </div>

                                <div className="input-box form-floating">
                                    <input
                                        type="tel"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="pin"
                                        name="pin"
                                        maxLength="6"
                                        pattern="[0-9]{10}"
                                        value={userLeadData.pin}
                                        onChange={handleChange}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (
                                                (isDigit || allowedKeys.includes(e.key)) &&
                                                (userLeadData.pin.length < 6 || e.key === "Backspace")
                                            ) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <label htmlFor="floatingInput" className=" mt-2">Pin Code*</label>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* **************Contact Person Address toggle******************* */}
                    <div
                        className="Person-Address-toggle mt-3"
                        onClick={() => handleIconClick("form4")}
                    >
                        <span className="toggle-text">Contact Person Address Details</span>
                        <span className=" float-end">
                            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                        </span>
                    </div>

                    {activeForm === "form4" && (
                        <div className=" container-fluid">
                            <div>
                                <span>Same as Installation Address</span>
                                <span className="" style={{ marginLeft: "40px" }}>
                                    <input
                                        type="checkbox"
                                        checked={useSameData}
                                        onChange={handleCheckboxChange}
                                    />
                                </span>
                            </div>
                            <div
                                className="container shadow mb-3 bg-body rounded mt-4"
                                id="form4"
                            >
                                <form className="Person-Address-form p-2">
                                    <div className="">
                                        <label className="select-search-label mt-1">Country*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="IndustrySeg"
                                            placeholder="Select Country"
                                            styles={style}
                                            isSearchable={false}
                                            value={{ value: '10001', label: 'India' }}
                                            onChange={handleSelectCountryOne}
                                            options={optionCountryOne.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>

                                    {/* <div className="">
                  <label className="select-search-label mt-1">State*</label>
                  <Select
                    className=" basic-single form-control p-1"
                    classNamePrefix="select"
                    name="IndustrySeg"
                    placeholder="Select"
                    isSearchable
                    styles={style}
                    value={selectStateOne}
                    onChange={handleSelectStateOne}
                    options={optionState.map((data) => ({
                      value: data.code,
                      label: data.name,
                    }))}
                  />
                </div> */}

                                    {/* {console.log("selectStateOne",selectStateOne)} */}
                                    <div className="">
                                        <label className="select-search-label mt-1">State*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="state"
                                            placeholder="Select State"
                                            isSearchable
                                            styles={style}
                                            value={selectStateOne}
                                            onChange={handleSelectStateOne}
                                            options={optionStateOne.map((data) => ({
                                                value: data.code,
                                                label: data.name,
                                            }))}
                                        />
                                    </div>

                                    {/* {console.log("selectCityOne",selectCityOne)} */}
                                    <div className="">
                                        <label className="select-search-label mt-1">City*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="City"
                                            placeholder="Select City"
                                            isSearchable
                                            styles={style}
                                            // value={cityType.find(
                                            //   (city) => city.CityCode === selectCityOne.value
                                            // )}
                                            value={selectCityOne}
                                            onChange={handleSelectCityOne}
                                            options={cityTypeOne.map((data) => ({
                                                value: data.CityCode,
                                                label: data.CityName,
                                            }))}
                                        />
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1">Area*</label>
                                        <Select
                                            options={areaList.map((area) => ({
                                                value: area.AreaCode,
                                                label: `${area.AreaName} (${area.AreaCode})`,
                                            }))}
                                            className=" form-control form-control-sm p-1"
                                            placeholder="Search Area"
                                            isSearchable
                                            styles={style}
                                            value={selectAreaOne}
                                            onChange={handleSelectAreaOne}
                                        />
                                        {/* <label htmlFor="floatingSelectArea">Area*</label> */}
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1">Building Name*</label>
                                        <Select
                                            options={buildingList.map((building) => ({
                                                value: building.BuildingCode,
                                                label: `${building.BuildingName} (${building.BuildingCode})`,
                                            }))}
                                            className="form-control form-control-sm p-1"
                                            placeholder="Search Building"
                                            styles={style}
                                            isSearchable
                                            value={selectBuildingOne}
                                            onChange={(selectedOption) =>
                                                setSelectBuildingOne(selectedOption)
                                            }
                                        />
                                    </div>

                                    <div className="input-box form-floating">
                                        {selectAreaOne && selectAreaOne.label.includes("Other") ? (
                                            <>
                                                <input
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control input-text form-control-sm mt-1"
                                                    name="specifyAreaOne"
                                                    value={userLeadData.specifyAreaOne}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="floatingInput" className="mt-2">
                                                    Specific Area Name
                                                </label>
                                            </>
                                        ) : null}
                                    </div>

                                    <div className="input-box form-floating">
                                        {selectBuildingOne &&
                                            selectBuildingOne.label.includes("Other") ? (
                                            <>
                                                <input
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control input-text form-control-sm mt-1"
                                                    id="buildingName"
                                                    name="SpecifyBuildingOne"
                                                    value={userLeadData.specifyBuildingOne}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="floatingInput" className="mt-2">
                                                    Specific Building Name
                                                </label>
                                            </>
                                        ) : null}
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="buildingNum"
                                            name="buildingNumOne"
                                            value={userLeadData.buildingNumOne}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Building No./Plot No.*
                                        </label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="block"
                                            name="blockOne"
                                            value={userLeadData.blockOne}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">Block*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="floor"
                                            name="floorOne"
                                            value={userLeadData.floorOne}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">Floor*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="tel"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="pin"
                                            name="pinOne"
                                            maxLength="6"
                                            pattern="[0-9]{10}"
                                            value={userLeadData.pinOne}
                                            onChange={handleChange}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key)) &&
                                                    (userLeadData.pinOne.length < 6 ||
                                                        e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">Pin Code*</label>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}





                    <div
                        className="Remarks-toggle mt-3"
                        onClick={() => handleIconClick("form7")}
                    >
                        <span className="toggle-text">Remarks</span>
                        <span className=" float-end">
                            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                        </span>
                    </div>



                    {activeForm === "form7" && (
                        <div
                            className="container shadow mb-3 bg-body rounded mt-4"
                            id="form7"
                        >
                            <form className="Remarks-form p-2">
                                {/* <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="remark"
                                        name="remark"
                                        value={userLeadData.remark}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">Remarks</label>
                                </div> */}
                                <div className="remark-area">
                                    <label htmlFor="floatingInput">Remarks</label>
                                    <textarea
                                        type="text"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm textarea"
                                        id="remark"
                                        name="remark"
                                        value={userLeadData.remark}
                                        onChange={handleChange}
                                    />
                                </div>
                            </form>
                        </div>
                    )}

                    <div className=" text-center mt-5 mb-3">
                        <button
                            type="submit"
                            className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                            onClick={handleSubmit}
                            disabled={leadStatus == "1"}
                        >
                            Save
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default BusinessLeadForm;
